// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-09T16:38:33.671Z
// Property: Kenzie Park (ID: 5174477956579328)
// Collections: 16 amenities, 4 floorplans (live), 18 photos, 82 POIs, 4 reviews, 1 virtual tours, 7 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5174477956579328",
  "property_external_id": "4981187",
  "property_zillow_url": "https://www.zillow.com/apartments/san-antonio-tx/deer-creek/5XmFSy/",
  "property_apartments_url": "https://www.apartments.com/kenzie-park-san-antonio-tx/7x94c7x",
  "property_google_business_url": "https://www.google.com/maps/place/Deer+Creek+Apartments/@29.4707724,-98.6506885,17z/data=!4m13!1m7!3m6!1s0x865c5d2565be6b57:0xda8ce166495c1bb6!2s3379+Timber+View+Dr,+San+Antonio,+TX+78251!3b1!8m2!3d29.4707724!4d-98.6484998!3m4!1s0x865c5d250652197b:0xdc4d6a60c4b26861!8m2!3d29.4691046!4d-98.6465075",
  "property_linkedin_url": null,
  "property_hubspot_id": "8443201072",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "kenzie-park",
  "property_name": "Kenzie Park",
  "property_website_url": "https://www.kenziepark.com/",
  "property_domain": "https://www.kenziepark.com/",
  "property_address": "3379 Timber View Dr",
  "property_full_address": "3379 Timber View Dr, San Antonio, TX 78251",
  "property_address_1": "3379 Timber View Dr",
  "property_address_2": null,
  "property_address_city": "San Antonio",
  "property_address_state": "TX",
  "property_address_zip_full": "78251-1763",
  "property_address_zip": "78251",
  "property_address_country": "US",
  "property_address_county": "Bexar County",
  "property_neighborhood_address": "Pipers Meadow",
  "property_address_latitude": "29.4700946",
  "property_address_longitude": "-98.6471679",
  "property_email": "kenzie@alapts.com",
  "property_phone": "(210) 520-4343",
  "property_call_tracking_phone": "361-301-7281",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Polished Westover Hills living starts here.</strong> Choose a one- or two-bedroom apartment with granite countertops, stainless steel appliances, walk-in closets, and streamlined everyday conveniences—then explore layouts or schedule a tour when you’re ready.</p>",
  "property_long_description": "<p><strong>Polished Westover Hills living, with everyday convenience close by.</strong> At Kenzie Park, you can choose a one- or two-bedroom apartment with finishes that make daily routines feel streamlined: granite countertops, stainless steel appliances, decorative tile backsplash, a deep kitchen sink with gooseneck faucet, walk-in closets, and washer/dryer options in select homes.</p><p>Beyond your front door, the community keeps things easy with a resort-style pool, fitness center, resident clubhouse with lounge space, outdoor grilling areas, controlled-access gates, an on-site laundry care center, valet trash, and 24/7 online resident services. Explore the full lineup of <a href=\"/amenities\">amenities and finishes</a> or compare <a href=\"/floor-plans\">one- and two-bedroom layouts</a> when you’re ready.</p><p>Set in Westover Hills, you’re close to the Highway 151 corridor, SeaWorld San Antonio, Northwest Vista College, Christus Santa Rosa Hospital–Westover Hills, Ingram Park Mall, Culebra Road dining, and Cathedral Rock Park’s trails—connecting relaxed residential living with the west side’s shopping, recreation, and major employment centers.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019d02ee-2d52-761b-9751-79f8a971bedd.webp",
  "property_featured_image_media": {
    "alt_text": "Modern kitchen and dining area with granite countertops, stainless steel appliances, and rattan chairs.",
    "public_id": "019d02ee-2d52-761b-9751-79f8a971bedd",
    "storage_key": "property/5174477956579328/019d02ee-2d52-761b-9751-79f8a971bedd.webp",
    "width": 1240,
    "height": 827
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "312",
  "property_year_built": "2005",
  "property_year_renovated": "2022",
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "81.73076923076923",
  "property_admin_fee": "150",
  "property_application_fee": "75",
  "property_fees_deposit_info": "Application Fee $75\nAdministrative Fee $150\nNon-Refundable Pet Fee $300 / pet\nMonthly Pet Rent $20 / pet\nApplication Approval Fee Starting At $300",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "20",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, with a monthly pet rent of $20 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, with a monthly pet rent of $20 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://8879183.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://kenziepark.loftliving.com/login",
  "property_apply_now_url": "https://8879183.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019e6fb6-f091-76d7-9f72-66def8e002e0.webp",
  "property_primary_logo_media": {
    "alt_text": "Kenzie Park Premier Apartments logo.",
    "public_id": "019e6fb6-f091-76d7-9f72-66def8e002e0",
    "storage_key": "property/5174477956579328/019e6fb6-f091-76d7-9f72-66def8e002e0.webp",
    "width": 1668,
    "height": 945
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019e6fb6-855e-731e-935b-a4052144c0b0.webp",
  "property_secondary_logo_media": {
    "alt_text": "Kenzie Park Premier Apartments Logo",
    "public_id": "019e6fb6-855e-731e-935b-a4052144c0b0",
    "storage_key": "property/5174477956579328/019e6fb6-855e-731e-935b-a4052144c0b0.webp",
    "width": 1668,
    "height": 945
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019e6fb6-816d-7069-86dc-b80751e2e8fa.webp",
  "property_icon_media": {
    "alt_text": "Property management logo with four colorful segments forming a K shape.",
    "public_id": "019e6fb6-816d-7069-86dc-b80751e2e8fa",
    "storage_key": "property/5174477956579328/019e6fb6-816d-7069-86dc-b80751e2e8fa.webp",
    "width": 504,
    "height": 504
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019e6fb6-816d-7069-86dc-b80751e2e8fa.webp",
  "property_fav_icon_media": {
    "alt_text": "Property management logo with four colorful segments forming a K shape.",
    "public_id": "019e6fb6-816d-7069-86dc-b80751e2e8fa",
    "storage_key": "property/5174477956579328/019e6fb6-816d-7069-86dc-b80751e2e8fa.webp",
    "width": 504,
    "height": 504
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019e6fb6-81d8-7309-bdd1-611ee3a24be0.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Kenzie Park Premier Apartments logo",
    "public_id": "019e6fb6-81d8-7309-bdd1-611ee3a24be0",
    "storage_key": "property/5174477956579328/019e6fb6-81d8-7309-bdd1-611ee3a24be0.webp",
    "width": 1668,
    "height": 945
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019e6fb6-8240-71cc-9449-832611a62825.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Kenzie Park Premier Apartments logo.",
    "public_id": "019e6fb6-8240-71cc-9449-832611a62825",
    "storage_key": "property/5174477956579328/019e6fb6-8240-71cc-9449-832611a62825.webp",
    "width": 1668,
    "height": 945
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#00586e",
  "property_secondary_color": "#919a3e",
  "property_font_color": "#2e2a25",
  "property_color_4": "#84235f",
  "property_color_3": "#f18c20",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "499 - 939",
  "property_sqft_min": "499",
  "property_sqft_max": "939",
  "property_price_range": "826.83 - 1183.16",
  "property_price_min": "826.83",
  "property_price_max": "1183.16",
  "property_available_units": 57,
  "property_facebook_url": "https://www.facebook.com/KenzieParkApartments",
  "property_instagram_url": "https://www.instagram.com/kenzieparkapts",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJexlSBiVdXIYRYWiyxGBqTdw",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/timber-ridge-apartments-san-antonio",
  "property_tiktok_url": "https://www.tiktok.com/@kenzieparkapartments",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Convenience, polish, and places to unwind.</strong> Kenzie Park keeps daily living streamlined with Spectrum cable and Wi-Fi, 24/7 online resident services, valet trash, and a virtual moving concierge. Recharge at the resort-style pool, fitness center, clubhouse lounge, or grilling areas, then come home to finishes like granite countertops, stainless steel appliances, decorative tile backsplash, and a deep kitchen sink with gooseneck faucet in select San Antonio apartments.</p>",
  "property_home_floorplans_blurb": "<p><strong>Find your fit at Kenzie Park.</strong> Choose from streamlined one-bedroom apartments and spacious two-bedroom layouts in San Antonio, with open living areas, practical kitchens, walk-in closets, and private balconies. Select homes add washer/dryer convenience, while standout finishes like granite countertops, stainless steel appliances, decorative tile backsplash, deep sinks with gooseneck faucets, and refreshed bath details bring polish to the everyday.</p>",
  "property_home_gallery_blurb": "<p><strong>Take a closer look at Kenzie Park.</strong> Preview bright kitchens with stainless steel appliances, granite surfaces, white cabinetry, and tile accents, plus furnished living spaces, sunlit bedrooms, and balcony moments. The gallery also captures the pool, shaded seating, grilling areas, fitness center, and clubhouse with vaulted ceilings, a stone fireplace, shuffleboard, and a bold green refreshment station.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Westover Hills keeps San Antonio close.</strong> From Kenzie Park, Highway 151 and Loop 1604 put daily stops, dining, and outdoor escapes within easy reach. Grab dinner near Westover Marketplace, meet up at Viola’s Ventanas, pick up Rudy’s barbecue, or unwind at Cathedral Rock Park, Tom Slick Park, and Heritage Duck Pond Park. Explore the map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see the location in person.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents have great things to say about Kenzie Park.</strong> Reviews call out the friendly office team, quick maintenance—often completed the same or next day—plus clean grounds, easy parking, updated homes, and reasonable pricing. From “Love coming home everyday” to “I definitely recommend,” the feedback points to supportive service and comfortable apartment living in Westover Hills.</p>",
  "property_neighborhood_blurb": "<p><strong>Westover Hills puts the west side within easy reach.</strong> From Kenzie Park, your map opens to the Highway 151 and Loop 1604 corridor—where everyday errands, Hill Country views, and San Antonio favorites sit close together. Pick up dinner around Westover Marketplace, meet friends for Tex-Mex at Viola’s Ventanas, grab barbecue from Rudy’s, or make a low-key escape to Cathedral Rock Park, Tom Slick Park, or the Heritage Duck Pond Park trail. With nearby routes connecting you toward Alamo Ranch, Loop 410, and major area campuses along 151, this neighborhood keeps plans flexible without losing its relaxed residential feel. Explore the map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Kenzie Park fits into your Westover Hills routine.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that keep your day moving.</strong> At Kenzie Park, everyday convenience is built into the details—from move-in-ready Spectrum cable and Wi-Fi to 24/7 online resident services, valet trash, and a virtual moving concierge that helps simplify the transition.</p><p>When you want to recharge, head to the resort-style pool, work out in the fitness center, meet the moment in the clubhouse lounge, or take dinner outside at the community grilling areas. Inside your San Antonio apartment, select homes add washer and dryer convenience, while granite countertops, stainless steel appliances, decorative tile backsplash, and a deep kitchen sink with gooseneck faucet bring a polished finish to your routine. See more in the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the amenities in person.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make Kenzie Park home?</strong> Choose a polished one- or two-bedroom apartment with granite countertops, stainless steel appliances, walk-in closets, and select washer/dryer options—all in a Westover Hills setting built for everyday convenience. Start your application online today and take the next step.</p>",
  "property_contactus_blurb": "<p><strong>Have questions? We’re here to help.</strong> Contact the Kenzie Park leasing team for details about one- and two-bedroom apartments, everyday conveniences, availability, or directions to our Westover Hills community. Reach out today and let us help you take the next step.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Kenzie Park?</strong> Start here for quick answers about the community, leasing, apartment features, and everyday living in Westover Hills. If you need more details or help choosing your next step, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Start with the space that fits your day.</strong> Kenzie Park offers a focused collection of one- and two-bedroom apartments in San Antonio, from efficient one-bath layouts to roomier two-bath options. Open living areas, practical kitchens, walk-in closets, and private balconies help each plan feel easy to arrange, while select homes add washer/dryer convenience. Look for finishes that elevate the everyday—sleek granite countertops, stainless steel appliances, decorative tile backsplash, deep sinks with gooseneck faucets, and updated bath details—then compare current pricing and availability right on the floor plan cards. Browse the <a href=\"/gallery\">photo gallery</a> for a closer look, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite layout in person.</p>",
  "property_gallery_blurb": "<p><strong>See Kenzie Park in focus.</strong> Browse a gallery that moves from polished apartment interiors to the community spaces that shape the everyday view. Photos highlight bright kitchens with stainless steel appliances, granite surfaces, white cabinetry, and tile accents; furnished living rooms with layered textures; bedrooms with natural light; and balconies set up for a quiet pause.</p><p>Outside your door, look for the pool from above, shaded seating, grilling areas, and a clubhouse scene with vaulted ceilings, a stone fireplace, shuffleboard, and a bold green refreshment station. You’ll also get a closer look at the fitness center and shared lounge spaces before you compare <a href=\"/floor-plans\">one- and two-bedroom layouts</a>, explore <a href=\"/virtual-tours\">virtual tours</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> in Westover Hills.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Kenzie Park on the map.</strong><br>See available one- and two-bedroom apartments, then zoom out to Westover Hills connections near the Highway 151 corridor, west side shopping, dining, recreation, and major employment centers.</p>",
  "property_pets_blurb": "<p><strong>Bring the pets that make your apartment feel like home.</strong> Kenzie Park welcomes cats and dogs, with room for up to two pets per home and no weight limit, so your daily routine can fit the companion you already love. Step out for quick leashed walks around the community, or head to nearby Tom Slick Park when your dog needs off-leash time, separate large- and small-dog areas, and pet-friendly water stops.</p><p>Back at home, everyday conveniences like controlled-access gates, valet trash, and an on-site laundry care center help keep pet life running smoothly. Explore more <a href=\"/amenities\">community amenities</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Kenzie Park supports a pet-friendly San Antonio routine.</p>",
  "property_referafriend_blurb": "<p><strong>Share polished Westover Hills living.</strong> If you love the everyday ease of Kenzie Park—from stylish one- and two-bedroom homes to inviting spaces like the pool, fitness center, and clubhouse—refer a friend and invite them to find their next apartment here.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access made easy.</strong> Log in anytime to pay rent, submit maintenance requests, and manage your Kenzie Park account through convenient 24/7 online resident services—so everyday apartment living stays as streamlined as the finishes inside your Westover Hills home.</p>",
  "property_reviews_blurb": "<p><strong>See why residents recommend Kenzie Park.</strong> In reviews, residents consistently highlight friendly, helpful service, a caring office team, and maintenance requests handled quickly—often “that day or next day.” You’ll also see praise for comfortable apartment homes, updated renovations, clean grounds, easy parking, and reasonable pricing.</p><p>As you browse the ratings, you’ll notice a common thread: people appreciate feeling supported here. From helpful staff to efficient service requests, Kenzie Park earns comments like “Love coming home everyday” and “I definitely recommend.” Read what residents have shared and get a clearer feel for everyday apartment living in Westover Hills.</p>",
  "property_created_at": "1752256300368",
  "property_scheduletour_blurb": "<p><strong>See Kenzie Park in person.</strong> Tour polished one- and two-bedroom apartments with granite countertops, stainless steel appliances, walk-in closets, and select washer/dryer options—then explore the resort-style pool, fitness center, clubhouse lounge, and gated community setting that make everyday Westover Hills living feel easy.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—we’ve received your inquiry.</strong><br>Our leasing team will follow up soon. In the meantime, picture polished Westover Hills living with granite countertops, stainless steel appliances, walk-in closets, and everyday conveniences designed to keep life moving smoothly at Kenzie Park.</p>",
  "property_virtualtours_blurb": "<p><strong>Walk through Kenzie Park before you walk through the door.</strong> Start with the community tour for a quick feel for the setting, then step inside the clubhouse to see the lounge-style interiors, shuffleboard area, and gathering space from multiple angles. The fitness center tour lets you preview the equipment layout and mirrored workout room, while the one-bedroom apartment tour gives you a closer look at everyday flow, finishes, storage, and natural light.</p><p>Use these virtual tours to compare what matters most from wherever you are, then browse current <a href=\"/floor-plans\">floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience Kenzie Park in San Antonio in person.</p>",
  "property_copyright": "2025 All Rights Reserved. Kenzie Park",
  "property_seo_title_home": "Kenzie Park | Apartments in San Antonio, TX",
  "property_seo_description_home": "\"Welcome to Kenzie Park in vibrant San Antonio, TX—your gateway to modern living! Choose from stylish one and two-bedroom floor plans, each featuring luxurious amenities like a state-of-the-art fitness center, serene pool, and resident clubhouse. Enjoy convenience with access gates, online services, and in-unit washers and dryers, all designed to elevate your lifestyle. Your new home awaits—embrace comfort and sophistication at Kenzie Park today!\"",
  "property_seo_title_floorplans": "Floor Plans | 1 - 2 Apartments in San Antonio, TX",
  "property_seo_description_floorplans": "Unlock the door to your ideal living space at Kenzie Park in vibrant San Antonio, TX. With thoughtfully designed one and two bedroom floor plans, our community offers the perfect blend of comfort and style. Dive into a diverse range of options that suit your lifestyle—your perfect home awaits! Browse our available apartment homes today and start your journey to exceptional living.",
  "property_seo_title_amenities": "Amenities | San Antonio, TX Apartments for Rent",
  "property_seo_description_amenities": "\"Welcome to Kenzie Park in vibrant San Antonio, TX, where modern living meets comfort and style. Our thoughtfully designed one and two-bedroom apartments boast exceptional features like full-size washers and dryers, sleek tile backsplashes, and a tech-savvy package that elevates your lifestyle. Enjoy resort-style perks such as a state-of-the-art fitness center, a sparkling pool, and relaxing grill area, all within a gated community. Unwind in our resident clubhouse or take advantage of convenient online services. Your new home awaits — check out our unique amenities today!\"",
  "property_seo_title_gallery": "Gallery | Apartments in San Antonio, TX",
  "property_seo_description_gallery": "\"Step into your future at Kenzie Park in San Antonio, TX, where modern living meets comfort. Our stunning photo gallery offers a glimpse into community life, complete with resort-style amenities like a sparkling pool, fully-equipped fitness center, and cozy grill area. With a variety of thoughtfully designed one and two-bedroom floor plans, every home boasts luxury finishes, technology packages, and convenient in-unit laundry. Picture yourself enjoying hassle-free living with online resident services and valet trash. Don’t just imagine it—experience the vibrant lifestyle waiting for you at Kenzie Park!\"",
  "property_seo_title_virtualtours": "Virtual Tours | Kenzie Park Apartments",
  "property_seo_description_virtualtours": "Experience the vibrant lifestyle of Kenzie Park in San Antonio, TX, where your dream apartment awaits! From spacious one-bedroom havens to stylish two-bedroom retreats, our community offers floor plans designed for comfort and convenience. Dive into the heart of Kenzie Park—take a virtual tour today and envision your new home!",
  "property_seo_title_interactivemap": "Interactive Map | Kenzie Park Apartments",
  "property_seo_description_interactivemap": "\"Experience the ultimate blend of comfort and modern living at Kenzie Park in San Antonio, TX. Our thoughtfully designed one and two-bedroom apartments feature stylish amenities like full-size washers and dryers, sleek tile backsplashes, and an inviting resident clubhouse. Enjoy easy access with our gated entry, unwind by the pool, or maintain your fitness routine in our state-of-the-art fitness center. Use our interactive community map to find your ideal apartment, explore pricing options, and embark on your new lifestyle today!\"",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in San Antonio, TX",
  "property_seo_description_neighborhood": "Experience the vibrant lifestyle at Kenzie Park in San Antonio, TX! Nestled in a thriving neighborhood, our community offers a variety of charming dining, shopping, and entertainment options. Whether you're drawn to our spacious one or two-bedroom floor plans or the welcoming atmosphere, you’ll find yourself just steps away from local favorites and hidden gems. See what's around our community and uncover all the excitement that awaits at Kenzie Park!",
  "property_seo_title_contact": "Contact Us | Kenzie Park",
  "property_seo_description_contact": "Uncover the charm of Kenzie Park in San Antonio, TX, where spacious one and two-bedroom floor plans await your personal touch. Whether you're looking for modern comforts or vibrant community living, our dedicated leasing team is here to help. Have questions? Reach out today and take the first step to your ideal home!",
  "property_seo_title_faqs": "FAQs | Apartments in San Antonio, TX",
  "property_seo_description_faqs": "Uncover the answers to your burning questions at Kenzie Park, San Antonio's premier apartment community. Our FAQs page is your go-to resource for insights on our stylish one and two-bedroom floor plans, luxurious amenities like the fitness center and pool, and convenient online resident services. Dive into information about our modern kitchens, in-unit washers and dryers, and exclusive community features. Navigate life at Kenzie Park with ease – browse our FAQs and find everything you need to know today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in San Antonio, TX",
  "property_seo_description_reviews": "\"At Kenzie Park in San Antonio, TX, life is more than just a home—it's a vibrant community where comfort meets convenience. With spacious one and two-bedroom floor plans, state-of-the-art amenities like a fitness center, refreshing pool, and modern kitchen features, our residents enjoy a lifestyle that truly stands out. Hear firsthand experiences and reviews from those who call Kenzie Park home. Curious? See what our residents have to say about living at our community!\"",
  "property_seo_title_applynow": "Apply Now | Apartments in San Antonio, TX",
  "property_seo_description_applynow": "\"Step into Kenzie Park, your ideal San Antonio sanctuary featuring spacious one and two-bedroom apartments. Enjoy a host of amenities like a state-of-the-art fitness center, inviting pool, and resident clubhouse, all within a secure, gated community. With modern kitchen appliances, full-size in-unit washers, and 24/7 online resident services, convenience meets comfort at every turn. Ready to elevate your lifestyle? Find your new home and lease online today!\"",
  "property_seo_title_residentaccess": "Resident Access | Kenzie Park",
  "property_seo_description_residentaccess": "\"Embrace the convenience of Kenzie Park in San Antonio, TX! Log into your resident portal for seamless rent payments, maintenance scheduling, and exclusive community updates—all at your fingertips. Your comfort and ease await!\"",
  "property_seo_title_referafriend": "Refer A Friend | Kenzie Park",
  "property_seo_description_referafriend": "\"At Kenzie Park in sunny San Antonio, TX, friendships flourish! Refer a friend today and unlock exclusive perks while building a vibrant community where great neighbors become lifelong friends. Join us in creating unforgettable memories!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Kenzie Park",
  "property_seo_description_scheduletour": "Step into your future at Kenzie Park, where vibrant living meets modern comfort in the heart of San Antonio, TX. Immerse yourself in our stunning community amenities and beautifully designed apartments. Catch a glimpse of your new lifestyle—schedule a tour today and experience the Kenzie Park difference!",
  "property_seo_title_privacy": "Privacy Policy | Kenzie Park",
  "property_seo_description_privacy": "At Kenzie Park in San Antonio, TX, your privacy matters. Learn how we safeguard your personal information while you enjoy our vibrant community and exceptional living experience. View our privacy policy for peace of mind.",
  "property_seo_title_accessibility": "Website Accessibility | Kenzie Park",
  "property_seo_description_accessibility": "\"At Kenzie Park in San Antonio, TX, we embrace digital inclusion for all. Our Accessibility Statement outlines our commitment to providing an equitable online experience, ensuring everyone can connect with our vibrant community. Join us in creating a welcoming space where everyone belongs.\"",
  "property_seo_title_sitemap": "Sitemap | Kenzie Park",
  "property_seo_description_sitemap": "\"Navigate your way to your dream home at Kenzie Park in vibrant San Antonio, TX. Our sitemap offers a clear path to all the features and amenities that make our community unique. Uncover the perfect lifestyle today!\"",
  "property_seo_title_thankyou": "Thank You | Kenzie Park",
  "property_seo_description_thankyou": "Thank you for reaching out to Kenzie Park in vibrant San Antonio! Your interest means a lot to us. A dedicated team member will soon connect with you to discuss how Kenzie Park can become your next home. Stay tuned for personalized assistance and exciting opportunities!",
  "property_seo_title_pets": "Pet Policy | Apartments in Riverview, FL",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791234319903",
  "amenities": [
    {
      "id": "custom_8f72bdfc-24a3-41ca-a9da-7b00cf192d9d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "custom",
      "external_id": "P000000594",
      "title": "Access Gates",
      "amount": "0.0000",
      "description": "Controlled Access Gates",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f0687ff5-17b6-4613-8536-a1fc07f40e30",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_26150294-f55b-4b22-9f25-d6504ea5ca14",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "custom",
      "external_id": "P000000621",
      "title": "Counters",
      "amount": "0.0000",
      "description": "Sleek Granite Countertops",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d79ecd6f-ebe1-4ec5-ab82-8618009d0d58",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "Modern 24-Hour Fitness Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e3abd286-0539-4a51-8e7c-2482e476c5fe",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "custom",
      "external_id": "P000000644",
      "title": "Grill Area",
      "amount": "0.0000",
      "description": "Community Grilling Areas",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7812e93e-a255-4495-b97b-2c92fd2241d1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Stainless Steel Appliances",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_666d6183-17d6-4b46-9a68-5fb0d3112f71",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "custom",
      "external_id": "P000000656",
      "title": "Laundry Rooms",
      "amount": "0.0000",
      "description": "Onsite Resident Laundry Care Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1ca0c456-6aaf-4122-be6c-3717f0dba78f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4ac848d8-8770-4fd0-865e-72c5503801ee",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "custom",
      "external_id": "P000000669",
      "title": "Pool",
      "amount": "0.0000",
      "description": "Resort-Inspired Pool",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_29441288-81bd-458e-aaac-2812e2204b11",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "custom",
      "external_id": "P000000675",
      "title": "Select Homes",
      "amount": "0.0000",
      "description": "*In Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4f5f312b-7434-4925-8896-95c290e6e4e4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "custom",
      "external_id": "P000000676",
      "title": "Sink",
      "amount": "0.0000",
      "description": "Updated Bathroom Faucets & Sinks",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ff47f747-cb2c-4a58-be2d-be58d7d1bb1a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "custom",
      "external_id": "P000000691",
      "title": "Technology Package",
      "amount": "0.0000",
      "description": "Move In Ready Spectrum Cable and Wifi ",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d333be62-01b1-4357-9de4-98bff7022823",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "custom",
      "external_id": "P000000695",
      "title": "Tile Backsplash",
      "amount": "0.0000",
      "description": "Decorative Tile Backsplash",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_870351ab-2d41-42d0-b288-703a2f80d922",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "custom",
      "external_id": "P000000704",
      "title": "W&D Included",
      "amount": "0.0000",
      "description": "In-Home Washer and Dryers*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_847bb42f-feb3-4f33-aa8a-5ac0a7e14259",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "custom",
      "external_id": "P000002458",
      "title": "Valet Trash Service",
      "amount": "0.0000",
      "description": "Valet Trash Service",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7e3b6a39-81f1-4434-8ce5-de3f846bc1d6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "custom",
      "external_id": "P000002520",
      "title": "Resident Clubhouse",
      "amount": "0.0000",
      "description": "Resident Clubhouse",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_372af094-a9b7-4a0f-8fce-52259ca4a3ad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019e899b-67b2-71f0-a820-6227199b8809.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and cabanas.",
        "public_id": "019e899b-67b2-71f0-a820-6227199b8809",
        "storage_key": "property/5174477956579328/019e899b-67b2-71f0-a820-6227199b8809.webp",
        "width": 3072,
        "height": 2300
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and private cabanas.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and cabanas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_15b4a2b7-fc09-4e2a-b9e8-1d37c1d53f68",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019e899b-695e-7488-982f-a5bf99c6756d.webp",
      "image_media": {
        "alt_text": "A bright and airy living room with a white sofa, two accent chairs, a coffee table, and a balcony.",
        "public_id": "019e899b-695e-7488-982f-a5bf99c6756d",
        "storage_key": "property/5174477956579328/019e899b-695e-7488-982f-a5bf99c6756d.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Step into this stylish living room, perfect for relaxing or entertaining. Features a comfortable white sofa, chic accent chairs, and a modern coffee table.",
      "link": "",
      "alt_text": "A bright and airy living room with a white sofa, two accent chairs, a coffee table, and a balcony.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d9b06539-86cc-4425-9203-07f24dea6ae2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019e899b-61c1-77f3-8c11-0000376910b2.webp",
      "image_media": {
        "alt_text": "Interior of a modern fitness center with a unique multi-station workout machine.",
        "public_id": "019e899b-61c1-77f3-8c11-0000376910b2",
        "storage_key": "property/5174477956579328/019e899b-61c1-77f3-8c11-0000376910b2.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active and healthy in our state-of-the-art fitness center, featuring a versatile workout station and top-tier exercise equipment for a complete training experience.",
      "link": "",
      "alt_text": "Interior of a modern fitness center with a unique multi-station workout machine.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_00b49a34-5c31-4a35-8f59-0ef6b221a90c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019e899b-6830-7209-882f-1d7e6f13fca8.webp",
      "image_media": {
        "alt_text": "Shuffleboard table in a community game room.",
        "public_id": "019e899b-6830-7209-882f-1d7e6f13fca8",
        "storage_key": "property/5174477956579328/019e899b-6830-7209-882f-1d7e6f13fca8.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy friendly competition on the shuffleboard table in our resident game room, perfect for socializing and unwinding.",
      "link": "",
      "alt_text": "Shuffleboard table in a community game room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_635f990a-6b8e-4ea8-ba4a-decab5577d35",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019e899b-6047-72db-a6a2-a91a465fcdbd.webp",
      "image_media": {
        "alt_text": "Modern bathroom with gray vanity, granite countertop, and white bathtub.",
        "public_id": "019e899b-6047-72db-a6a2-a91a465fcdbd",
        "storage_key": "property/5174477956579328/019e899b-6047-72db-a6a2-a91a465fcdbd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed bathroom featuring a sleek gray vanity, elegant granite countertops, and a pristine white bathtub.",
      "link": "",
      "alt_text": "Modern bathroom with gray vanity, granite countertop, and white bathtub.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c357f19b-71a6-43ee-ad5d-84a07898e343",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019e899b-6573-7212-b6ac-df318740dd07.webp",
      "image_media": {
        "alt_text": "Modern kitchen with gray cabinets, granite countertops, stainless steel appliances, and wooden decor.",
        "public_id": "019e899b-6573-7212-b6ac-df318740dd07",
        "storage_key": "property/5174477956579328/019e899b-6573-7212-b6ac-df318740dd07.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Step into a beautifully appointed kitchen featuring sleek gray cabinetry, elegant granite countertops, and top-of-the-line stainless steel appliances. The perfect space for culinary creativity.",
      "link": "",
      "alt_text": "Modern kitchen with gray cabinets, granite countertops, stainless steel appliances, and wooden decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_17dca320-bb5c-4025-9fe3-255044df8fcf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019e899b-4af7-77fb-af24-637b96b1e4b0.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, white comforter, and green curtains.",
        "public_id": "019e899b-4af7-77fb-af24-637b96b1e4b0",
        "storage_key": "property/5174477956579328/019e899b-4af7-77fb-af24-637b96b1e4b0.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a comfortable queen-size bed with a waffle-knit comforter and plush pillows, accented by stylish wall art and a large window with green drapes.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, white comforter, and green curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4aff1346-45f3-49ef-838a-a9cedf0e67dc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019e899b-4c05-7302-9c45-b992cb4fe806.webp",
      "image_media": {
        "alt_text": "Kenzie Park logo and Starbucks sign on a honeycomb green tile wall with a coffee station.",
        "public_id": "019e899b-4c05-7302-9c45-b992cb4fe806",
        "storage_key": "property/5174477956579328/019e899b-4c05-7302-9c45-b992cb4fe806.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy complimentary coffee and refreshments at the Kenzie Park community lounge, featuring a unique honeycomb green tile backsplash and Starbucks service.",
      "link": "",
      "alt_text": "Kenzie Park logo and Starbucks sign on a honeycomb green tile wall with a coffee station.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_78e459d1-748d-4795-8a69-3b13ffe473a5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019e899b-38d3-747c-b448-1524eda89814.webp",
      "image_media": {
        "alt_text": "Modern living room with a white sofa, two armchairs, and a wooden coffee table on a jute rug.",
        "public_id": "019e899b-38d3-747c-b448-1524eda89814",
        "storage_key": "property/5174477956579328/019e899b-38d3-747c-b448-1524eda89814.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Step into this stylish and comfortable living room, featuring a plush white sofa, accent armchairs, and a warm wooden coffee table perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Modern living room with a white sofa, two armchairs, and a wooden coffee table on a jute rug.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_21926c4c-34f6-4b42-9b6f-f6aaae5b798e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019e899b-3864-7218-8f9c-81e8082f18ec.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, rowing machine, and stationary bike.",
        "public_id": "019e899b-3864-7218-8f9c-81e8082f18ec",
        "storage_key": "property/5174477956579328/019e899b-3864-7218-8f9c-81e8082f18ec.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring a variety of cardio equipment including treadmills, a rowing machine, and a stationary bike. Perfect for residents to maintain their active lifestyle.",
      "link": "",
      "alt_text": "Fitness center with treadmills, rowing machine, and stationary bike.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_acd0b8bf-9c8c-4002-af14-7690e86fde80",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019e899b-3873-71fb-9d01-64f6c9b271ae.webp",
      "image_media": {
        "alt_text": "Fitness center with weight bench, dumbbells, kettlebell, exercise balls, and rowing machine.",
        "public_id": "019e899b-3873-71fb-9d01-64f6c9b271ae",
        "storage_key": "property/5174477956579328/019e899b-3873-71fb-9d01-64f6c9b271ae.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring a weight bench, free weights, exercise balls, and a state-of-the-art rowing machine. The perfect place to achieve your wellness goals.",
      "link": "",
      "alt_text": "Fitness center with weight bench, dumbbells, kettlebell, exercise balls, and rowing machine.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1d879d91-57a0-4f47-9c3a-dfd55b734be6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019e899b-3cb2-73eb-a60a-fa7927dc2d31.webp",
      "image_media": {
        "alt_text": "Modern kitchen and dining area with granite countertops, stainless steel appliances, and a dining set with four chairs.",
        "public_id": "019e899b-3cb2-73eb-a60a-fa7927dc2d31",
        "storage_key": "property/5174477956579328/019e899b-3cb2-73eb-a60a-fa7927dc2d31.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Stylish kitchen and dining space featuring granite countertops, a full suite of stainless steel appliances, and a comfortable dining set, perfect for everyday living.",
      "link": "",
      "alt_text": "Modern kitchen and dining area with granite countertops, stainless steel appliances, and a dining set with four chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e57924d7-5f84-4119-ad47-7394f7601ebf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019e899b-435c-725e-9e5e-f5daa5de6b2f.webp",
      "image_media": {
        "alt_text": "Aerial view of a sparkling outdoor swimming pool with lounge chairs and umbrellas.",
        "public_id": "019e899b-435c-725e-9e5e-f5daa5de6b2f",
        "storage_key": "property/5174477956579328/019e899b-435c-725e-9e5e-f5daa5de6b2f.webp",
        "width": 3072,
        "height": 2300
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning outdoor swimming pool, featuring ample lounge seating and shaded areas for ultimate comfort.",
      "link": "",
      "alt_text": "Aerial view of a sparkling outdoor swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_21afb43f-dec0-4c2a-8a8a-f291d4f99eaf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019e899b-4359-74cb-a162-f358cdbeee3a.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
        "public_id": "019e899b-4359-74cb-a162-f358cdbeee3a",
        "storage_key": "property/5174477956579328/019e899b-4359-74cb-a162-f358cdbeee3a.webp",
        "width": 3072,
        "height": 2300
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor swimming pool, complete with comfortable lounge chairs and shaded umbrellas for your enjoyment.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_39c93489-41f5-47f6-9b5a-0557ee662214",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019e899b-40fc-703c-b479-b4c3f90463b6.webp",
      "image_media": {
        "alt_text": "A stylish common area with a stone fireplace, green velvet sofa, and leather armchairs.",
        "public_id": "019e899b-40fc-703c-b479-b4c3f90463b6",
        "storage_key": "property/5174477956579328/019e899b-40fc-703c-b479-b4c3f90463b6.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully designed common area, featuring a cozy stone fireplace and comfortable seating.",
      "link": "",
      "alt_text": "A stylish common area with a stone fireplace, green velvet sofa, and leather armchairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0dfc632d-1108-44fb-8fff-65839e921b8e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019e899b-41f6-76ad-9c2a-fe8418d71f02.webp",
      "image_media": {
        "alt_text": "Balcony with table and chairs overlooking a parking lot",
        "public_id": "019e899b-41f6-76ad-9c2a-fe8418d71f02",
        "storage_key": "property/5174477956579328/019e899b-41f6-76ad-9c2a-fe8418d71f02.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy your morning coffee or evening drinks on your private balcony, complete with a table and chairs.",
      "link": "",
      "alt_text": "Balcony with table and chairs overlooking a parking lot",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_529f94b7-d95e-4071-ac15-06cfe4bacc24",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019e899b-2f94-73da-a652-d5ed6b86439b.webp",
      "image_media": {
        "alt_text": "Gym equipment in a fitness center.",
        "public_id": "019e899b-2f94-73da-a652-d5ed6b86439b",
        "storage_key": "property/5174477956579328/019e899b-2f94-73da-a652-d5ed6b86439b.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "State-of-the-art fitness center with various exercise machines for a complete workout.",
      "link": "",
      "alt_text": "Gym equipment in a fitness center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_220b5a9e-20d4-4250-8191-8322a4a56c7a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019e899b-3044-70bf-9e8b-e4dba0ded4e1.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and wood-look flooring.",
        "public_id": "019e899b-3044-70bf-9e8b-e4dba0ded4e1",
        "storage_key": "property/5174477956579328/019e899b-3044-70bf-9e8b-e4dba0ded4e1.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this spacious and modern kitchen, featuring ample cabinet space, stainless steel appliances, and elegant finishes.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and wood-look flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_37d2d5b66660f5b79aa3b861",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Whataburger",
      "poi_type": "Restaurants",
      "poi_address": "8756 Grissom Rd, San Antonio, TX 78251, USA",
      "poi_short_description": "Circa-1950 fast-food chain for counter-serve burgers, some stacked with multiple patties.",
      "poi_long_description": "Circa-1950 fast-food chain for counter-serve burgers, some stacked with multiple patties.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1506-a2e4-7049-98a6-13c4b9b07c86.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-a2e4-7049-98a6-13c4b9b07c86",
        "storage_key": "property/5174477956579328/019f1506-a2e4-7049-98a6-13c4b9b07c86.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "https://locations.whataburger.com/tx/san-antonio/8756-grissom-rd.html/?utm_source=yextpages&utm_medium=locallistings&utm_campaign=yextpages",
      "poi_directions_map_url": "https://maps.google.com/?cid=9611877932287571635&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whataburger",
      "poi_latitude": "29.4792691",
      "poi_longitude": "-98.6573889",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-680-4463",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26d2-7343-b6be-1047ee9dba96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26d2-7343-b6be-1047ee9dba96",
        "storage_key": "property/5174477956579328/019f1504-26d2-7343-b6be-1047ee9dba96.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJsSmJBY7FQIYRs7Zqsg1AZIU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "ec_6dbab35d1c06a55523c58958",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Las Teresitas Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "8754 Grissom Rd, San Antonio, TX 78251, USA",
      "poi_short_description": "Tex-Mex dishes and a kids' menu feature at this informal family-friendly venue.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1506-a92b-735d-8cba-59f70a67ca4e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-a92b-735d-8cba-59f70a67ca4e",
        "storage_key": "property/5174477956579328/019f1506-a92b-735d-8cba-59f70a67ca4e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9452976918887038685&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "las-teresitas-mexican-restaurant",
      "poi_latitude": "29.4791803",
      "poi_longitude": "-98.657158",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-255-1341",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26d2-7343-b6be-1047ee9dba96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26d2-7343-b6be-1047ee9dba96",
        "storage_key": "property/5174477956579328/019f1504-26d2-7343-b6be-1047ee9dba96.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRbCJo8tdXIYR3X46eGy4L4M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_d6efc7f1ebb821e2223cca09",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Tia’s Taco Hut",
      "poi_type": "Restaurants",
      "poi_address": "10222 Military Dr W, San Antonio, TX 78251, USA",
      "poi_short_description": "Breakfast and other Mexican dishes are offered by this casual restaurant with a drive through.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1506-a350-77c8-8803-577a4ee361f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-a350-77c8-8803-577a4ee361f7",
        "storage_key": "property/5174477956579328/019f1506-a350-77c8-8803-577a4ee361f7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tiastacohuttx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13540790054400230808&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tias-taco-hut",
      "poi_latitude": "29.4489192",
      "poi_longitude": "-98.6858978",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 210-370-9058",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26d2-7343-b6be-1047ee9dba96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26d2-7343-b6be-1047ee9dba96",
        "storage_key": "property/5174477956579328/019f1504-26d2-7343-b6be-1047ee9dba96.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJqXHXRONDXIYRmAWr8s-M6rs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_776d5387cbcf3acc48f5a159",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Mattenga’s Pizzeria MILITARY DR. (near SeaWorld)",
      "poi_type": "Restaurants",
      "poi_address": "10222 Military Dr W Ste 111, San Antonio, TX 78251, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1506-a600-74b8-a179-9c95904c5a79.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-a600-74b8-a179-9c95904c5a79",
        "storage_key": "property/5174477956579328/019f1506-a600-74b8-a179-9c95904c5a79.webp",
        "width": 1273,
        "height": 1211
      },
      "poi_business_url": "https://mattengas.com/militarydr?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=12091818714904353920&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mattengas-pizzeria-military-dr-near-seaworld",
      "poi_latitude": "29.4488822",
      "poi_longitude": "-98.6861368",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 210-474-0045",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26d2-7343-b6be-1047ee9dba96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26d2-7343-b6be-1047ee9dba96",
        "storage_key": "property/5174477956579328/019f1504-26d2-7343-b6be-1047ee9dba96.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJw8lXtoFDXIYRgFxLVg7Fzqc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_c971dcd4bc0e182757d397b3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "10203 Military Dr W, San Antonio, TX 78251, USA",
      "poi_short_description": "Fast-food chain known for its chicken sandwiches, waffle fries, and breakfast options.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1506-a423-76ae-a442-16a42bb2a5c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-a423-76ae-a442-16a42bb2a5c4",
        "storage_key": "property/5174477956579328/019f1506-a423-76ae-a442-16a42bb2a5c4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/tx/hwy-151-military?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=1644903002763625025&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "29.4500798",
      "poi_longitude": "-98.685956",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 210-600-9984",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26d2-7343-b6be-1047ee9dba96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26d2-7343-b6be-1047ee9dba96",
        "storage_key": "property/5174477956579328/019f1504-26d2-7343-b6be-1047ee9dba96.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzR37QMpDXIYRQQKz4ZDe0xY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "ec_945ec1c8fcef637698c974ac",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Wicked Voodoo Espresso - Westover Hills",
      "poi_type": "Restaurants",
      "poi_address": "10234 TX-151 Ste 101, San Antonio, TX 78251, USA",
      "poi_short_description": "Fun coffee shop known for espresso drinks, cake bites and avocado toast, along with a drive-thru.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1506-a2da-770e-9f4d-10fa391d66ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-a2da-770e-9f4d-10fa391d66ad",
        "storage_key": "property/5174477956579328/019f1506-a2da-770e-9f4d-10fa391d66ad.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.wickedvoodooespresso.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15733748255643252847&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wicked-voodoo-espresso---westover-hills",
      "poi_latitude": "29.4486935",
      "poi_longitude": "-98.6849437",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1507-367c-7699-a717-38daf36a4467.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1507-367c-7699-a717-38daf36a4467",
        "storage_key": "property/5174477956579328/019f1507-367c-7699-a717-38daf36a4467.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJrTxWuyVDXIYRb7gJc62AWdo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_23434aaad58baec512193ada",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "The Jerk Shack",
      "poi_type": "Restaurants",
      "poi_address": "10234 TX-151 Ste 103, San Antonio, TX 78251, USA",
      "poi_short_description": "Humble window-serve for jerk chicken, patties & curries, plus veggie options & meat by the pound.",
      "poi_long_description": "Humble window-serve for jerk chicken, patties & curries, plus veggie options & meat by the pound.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1506-9fa7-757b-a47e-a0815edd5c54.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-9fa7-757b-a47e-a0815edd5c54",
        "storage_key": "property/5174477956579328/019f1506-9fa7-757b-a47e-a0815edd5c54.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "http://www.thejerkshacksatx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6456164703869525008&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-jerk-shack",
      "poi_latitude": "29.4488732",
      "poi_longitude": "-98.6849804",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 210-776-7780",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26d2-7343-b6be-1047ee9dba96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26d2-7343-b6be-1047ee9dba96",
        "storage_key": "property/5174477956579328/019f1504-26d2-7343-b6be-1047ee9dba96.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCYFxwM1fXIYRENyOiZfnmFk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "caribbean_restaurant"
    },
    {
      "id": "ec_171171bc65137ac08c3002a2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Chuy's",
      "poi_type": "Restaurants",
      "poi_address": "8438 TX-151, San Antonio, TX 78245, USA",
      "poi_short_description": "Chain serving \"big as yo' face\" burritos & other Tex-Mex dishes in kitschy, eclectic settings.",
      "poi_long_description": "Chain serving \"big as yo' face\" burritos & other Tex-Mex dishes in kitschy, eclectic settings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1506-a724-7288-a6cc-0b2e9834a1f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-a724-7288-a6cc-0b2e9834a1f5",
        "storage_key": "property/5174477956579328/019f1506-a724-7288-a6cc-0b2e9834a1f5.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.chuys.com/locations/tx/san-antonio/san-antonio-tx-hwy-151/6051?cmpid=br:chy_ag:ie_ch:loc_ca:CHYGMB_sn:gmb_gt:san-antonio-tx-6051_pl:locurl_rd:1050",
      "poi_directions_map_url": "https://maps.google.com/?cid=15553924154234714370&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chuys",
      "poi_latitude": "29.4359811",
      "poi_longitude": "-98.6542719",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 210-645-7208",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26d2-7343-b6be-1047ee9dba96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26d2-7343-b6be-1047ee9dba96",
        "storage_key": "property/5174477956579328/019f1504-26d2-7343-b6be-1047ee9dba96.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJY5asdrZcXIYRAjmHLJyj2tc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tex_mex_restaurant"
    },
    {
      "id": "ec_2c2dc52c37fdee45ddfdf192",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Rudy's \"Country Store\" and Bar-B-Q",
      "poi_type": "Restaurants",
      "poi_address": "10623 Westover Hills Blvd, San Antonio, TX 78251, USA",
      "poi_short_description": "Brisket, ribs & sides served up cafeteria-style in a no-frills setting with indoor picnic tables.",
      "poi_long_description": "Brisket, ribs & sides served up cafeteria-style in a no-frills setting with indoor picnic tables.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1506-a030-7139-90ac-6fcabddc5d54.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-a030-7139-90ac-6fcabddc5d54",
        "storage_key": "property/5174477956579328/019f1506-a030-7139-90ac-6fcabddc5d54.webp",
        "width": 600,
        "height": 800
      },
      "poi_business_url": "http://www.leonspringsbbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12420956638124341341&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rudys-country-store-and-bar-b-q",
      "poi_latitude": "29.46377889999999",
      "poi_longitude": "-98.6909758",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 210-653-7839",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26d2-7343-b6be-1047ee9dba96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26d2-7343-b6be-1047ee9dba96",
        "storage_key": "property/5174477956579328/019f1504-26d2-7343-b6be-1047ee9dba96.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJAWg3e-NCXIYRXXju2UAaYKw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "ec_8175f2b6311bf1a57e4521e9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Panera Bread",
      "poi_type": "Restaurants",
      "poi_address": "8531 TX-151, San Antonio, TX 78245, USA",
      "poi_short_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_long_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1506-a8d3-73a2-b3fe-43755e29406b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-a8d3-73a2-b3fe-43755e29406b",
        "storage_key": "property/5174477956579328/019f1506-a8d3-73a2-b3fe-43755e29406b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.panerabread.com/en-us/cafe/locations/tx/san-antonio/8531-state-highway-151?utm_medium=local&utm_source=google&utm_campaign=dpm-dist&utm_term=606330&utm_content=main",
      "poi_directions_map_url": "https://maps.google.com/?cid=13409454457734969985&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "panera-bread",
      "poi_latitude": "29.4383245",
      "poi_longitude": "-98.6548555",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 210-521-2399",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1507-367c-7699-a717-38daf36a4467.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1507-367c-7699-a717-38daf36a4467",
        "storage_key": "property/5174477956579328/019f1507-367c-7699-a717-38daf36a4467.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJwVi0_rVcXIYRgToSccjzF7o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "ec_e9e851b0b945f454a5c4c14b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Sazon Mexican Cafe",
      "poi_type": "Restaurants",
      "poi_address": "10015 Potranco Rd, San Antonio, TX 78251, USA",
      "poi_short_description": "Casual spot serving a range of traditional Mexican eats in a low-key environment.",
      "poi_long_description": "Casual spot serving a range of traditional Mexican eats in a low-key environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1506-aa5c-72c8-adfc-38232da32115.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-aa5c-72c8-adfc-38232da32115",
        "storage_key": "property/5174477956579328/019f1506-aa5c-72c8-adfc-38232da32115.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://sazonsatx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12605601266047020708&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sazon-mexican-cafe",
      "poi_latitude": "29.4359022",
      "poi_longitude": "-98.6896042",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 210-256-1500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26d2-7343-b6be-1047ee9dba96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26d2-7343-b6be-1047ee9dba96",
        "storage_key": "property/5174477956579328/019f1504-26d2-7343-b6be-1047ee9dba96.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJiT0ENBVDXIYRpG7yapAX8K4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_cfe96f17ba184f548b17fafe",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Willie's Grill & Icehouse",
      "poi_type": "Restaurants",
      "poi_address": "8739 TX-151, San Antonio, TX 78245, USA",
      "poi_short_description": "Long-running Texas chain for brews, burgers, chicken & seafood in a family-friendly setting.",
      "poi_long_description": "Long-running Texas chain for brews, burgers, chicken & seafood in a family-friendly setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1506-aca5-77fb-9488-45f109540e36.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-aca5-77fb-9488-45f109540e36",
        "storage_key": "property/5174477956579328/019f1506-aca5-77fb-9488-45f109540e36.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://williesgrillandicehouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11384934277868809873&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "willies-grill--icehouse",
      "poi_latitude": "29.4408922",
      "poi_longitude": "-98.6598497",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 210-375-5521",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26d2-7343-b6be-1047ee9dba96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26d2-7343-b6be-1047ee9dba96",
        "storage_key": "property/5174477956579328/019f1504-26d2-7343-b6be-1047ee9dba96.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5fmyL8tcXIYRke6J32dp_50",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_f8e264d065bba16c66b862b7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Thai Hut Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "9902 Potranco Rd, San Antonio, TX 78251, USA",
      "poi_short_description": "Colorful, informal strip-mall spot doling out familiar Thai cuisine, such as curry & drunken noodle.",
      "poi_long_description": "Colorful, informal strip-mall spot doling out familiar Thai cuisine, such as curry & drunken noodle.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1506-ae93-7628-a03b-405b4fdcb425.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-ae93-7628-a03b-405b4fdcb425",
        "storage_key": "property/5174477956579328/019f1506-ae93-7628-a03b-405b4fdcb425.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://thaihutrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3678644937885577161&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "thai-hut-restaurant",
      "poi_latitude": "29.435776",
      "poi_longitude": "-98.6856781",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 210-647-1035",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26d2-7343-b6be-1047ee9dba96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26d2-7343-b6be-1047ee9dba96",
        "storage_key": "property/5174477956579328/019f1504-26d2-7343-b6be-1047ee9dba96.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ87zdrRRDXIYRyW91qRQsDTM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "ec_0fbbc8fc9ba380704f02efbe",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Martha's Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "10619 Westover Hills Blvd, San Antonio, TX 78251, USA",
      "poi_short_description": "Informal destination offering a variety of traditional Mexican fare in a simple setting.",
      "poi_long_description": "Informal destination offering a variety of traditional Mexican fare in a simple setting.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8635771719945390574&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marthas-mexican-restaurant",
      "poi_latitude": "29.46412459999999",
      "poi_longitude": "-98.690413",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 210-520-0022",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26d2-7343-b6be-1047ee9dba96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26d2-7343-b6be-1047ee9dba96",
        "storage_key": "property/5174477956579328/019f1504-26d2-7343-b6be-1047ee9dba96.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0Wv9f-NCXIYR7om1AKBs2Hc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_d31661c904c51644eb67b01d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Viola's Ventanas",
      "poi_type": "Restaurants",
      "poi_address": "9660 Westover Hills Blvd, San Antonio, TX 78251, USA",
      "poi_short_description": "Spacious, airy eatery serving upscale Mexican cuisine in an old-world setting with outdoor seating.",
      "poi_long_description": "Spacious, airy eatery serving upscale Mexican cuisine in an old-world setting with outdoor seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1506-ae46-74e5-abef-fc171c8ed288.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-ae46-74e5-abef-fc171c8ed288",
        "storage_key": "property/5174477956579328/019f1506-ae46-74e5-abef-fc171c8ed288.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.violasventanas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13804863540689085291&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "violas-ventanas",
      "poi_latitude": "29.4692315",
      "poi_longitude": "-98.6743167",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 210-684-9660",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26d2-7343-b6be-1047ee9dba96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26d2-7343-b6be-1047ee9dba96",
        "storage_key": "property/5174477956579328/019f1504-26d2-7343-b6be-1047ee9dba96.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2RaDbttCXIYRa6ODuz-6lL8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_a02a62144659295d0f2ef74a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "9526 Military Dr W, San Antonio, TX 78251, USA",
      "poi_short_description": "Smaller Walmart grocery store selling clothing and home goods, with friendly staff and a pharmacy.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1506-b154-778b-8da1-c7e3a747d1af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-b154-778b-8da1-c7e3a747d1af",
        "storage_key": "property/5174477956579328/019f1506-b154-778b-8da1-c7e3a747d1af.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walmart.com/store/5226-san-antonio-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=12239183360953442787&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "29.4598764",
      "poi_longitude": "-98.6707181",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 210-536-2088",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26e4-76da-91e5-7c4ad0fbf848.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26e4-76da-91e5-7c4ad0fbf848",
        "storage_key": "property/5174477956579328/019f1504-26e4-76da-91e5-7c4ad0fbf848.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQZGYRCFDXIYR42GAumtQ2qk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_437207a16f57846a420d6aa2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "H-E-B plus!",
      "poi_type": "Shopping & Retail",
      "poi_address": "10718 Potranco Rd, San Antonio, TX 78251, USA",
      "poi_short_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_long_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1503-e0ae-70f2-a311-2e9dec1fe133.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-e0ae-70f2-a311-2e9dec1fe133",
        "storage_key": "property/5174477956579328/019f1503-e0ae-70f2-a311-2e9dec1fe133.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.heb.com/heb-store/US/tx/san-antonio/potranco-and-1604-h-e-b-plus--85?utm_source=google&utm_medium=organic&utm_campaign=gmb_stores",
      "poi_directions_map_url": "https://maps.google.com/?cid=18180495770658457862&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b-plus",
      "poi_latitude": "29.433607",
      "poi_longitude": "-98.70347300000002",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 210-681-2250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26e4-76da-91e5-7c4ad0fbf848.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26e4-76da-91e5-7c4ad0fbf848",
        "storage_key": "property/5174477956579328/019f1504-26e4-76da-91e5-7c4ad0fbf848.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOePYuwpDXIYRBsmWOpQYTvw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_7594bdf25812e2946ea9243f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "9427 Culebra Rd, San Antonio, TX 78251, USA",
      "poi_short_description": "Department store stocking a wide range of items, including electronics, apparel, and home furnishings.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1506-b340-733d-bd72-7c6ec31ce5f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-b340-733d-bd72-7c6ec31ce5f9",
        "storage_key": "property/5174477956579328/019f1506-b340-733d-bd72-7c6ec31ce5f9.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/4131-san-antonio-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=2782125882472747695&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "29.48743529999999",
      "poi_longitude": "-98.6681378",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 210-526-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26d1-75ba-b995-17c7cf51bbef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26d1-75ba-b995-17c7cf51bbef",
        "storage_key": "property/5174477956579328/019f1504-26d1-75ba-b995-17c7cf51bbef.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJh0r7CLdCXIYRr1I18b8YnCY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_d3996625818dbcf50fd612f7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "CVS Pharmacy y más",
      "poi_type": "Shopping & Retail",
      "poi_address": "7603 Culebra Rd, San Antonio, TX 78251, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1506-b216-74ac-bec9-a6b09070bee3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-b216-74ac-bec9-a6b09070bee3",
        "storage_key": "property/5174477956579328/019f1506-b216-74ac-bec9-a6b09070bee3.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/san-antonio-tx-pharmacies/7603-culebra-san-antonio-tx-78251/storeid=5857?WT.mc_id=LS_GOOGLE_RX_5857",
      "poi_directions_map_url": "https://maps.google.com/?cid=13911038483388103728&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy-y-ms",
      "poi_latitude": "29.4597861",
      "poi_longitude": "-98.6383176",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-680-0299",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1507-367e-7233-a886-b6337dade2fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1507-367e-7233-a886-b6337dade2fc",
        "storage_key": "property/5174477956579328/019f1507-367e-7233-a886-b6337dade2fc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvceW2d9cXIYRMPwi-8vvDcE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_f774bf3d61338cd05c8b7f31",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "11103 Military Dr W, San Antonio, TX 78251, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1506-b341-734a-a614-4ed95ce3d4ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-b341-734a-a614-4ed95ce3d4ba",
        "storage_key": "property/5174477956579328/019f1506-b341-734a-a614-4ed95ce3d4ba.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-11103+military+dr+w-san+antonio-tx-78251/id=9180",
      "poi_directions_map_url": "https://maps.google.com/?cid=13004932163866255486&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "29.44872569999999",
      "poi_longitude": "-98.7126859",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 210-679-5267",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26d4-764c-aab6-380cb77612fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26d4-764c-aab6-380cb77612fb",
        "storage_key": "property/5174477956579328/019f1504-26d4-764c-aab6-380cb77612fb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3_J5q69DXIYRfuBMY-bMerQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_6826f9cd3f72dd8a1815c078",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "8928 Culebra Rd, San Antonio, TX 78251, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1506-c34a-76ea-b597-a38ca4222e98.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-c34a-76ea-b597-a38ca4222e98",
        "storage_key": "property/5174477956579328/019f1506-c34a-76ea-b597-a38ca4222e98.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.7-eleven.com/locations/tx/san-antonio/8928-culebra-rd-36414?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=843087493518288467&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "29.4781092",
      "poi_longitude": "-98.6641016",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-520-0698",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1507-3694-77c8-84af-d516f398de55.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1507-3694-77c8-84af-d516f398de55",
        "storage_key": "property/5174477956579328/019f1507-3694-77c8-84af-d516f398de55.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJQYQnjctCXIYRU2a7xZs_sws",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_32f090887ccee36d102b5308",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Circle K",
      "poi_type": "Shopping & Retail",
      "poi_address": "9675 Culebra Rd, San Antonio, TX 78251, USA",
      "poi_short_description": "Convenience store and gas station with a car wash offering prepared foods, an ATM, and Amazon pickup services.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1506-b660-7277-a54e-2882726edbd0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-b660-7277-a54e-2882726edbd0",
        "storage_key": "property/5174477956579328/019f1506-b660-7277-a54e-2882726edbd0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.circlek.com/store-locator/US/san-antonio/9675-culebra-rd/2740991?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=14465664057960959075&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k",
      "poi_latitude": "29.4897981",
      "poi_longitude": "-98.6779137",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 210-684-2875",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1507-3694-77c8-84af-d516f398de55.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1507-3694-77c8-84af-d516f398de55",
        "storage_key": "property/5174477956579328/019f1507-3694-77c8-84af-d516f398de55.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJvd5r2LtCXIYRYwzmftFcwMg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_34ee61c22e6172ffdcc7ac9a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Culebra Meat Market 17",
      "poi_type": "Shopping & Retail",
      "poi_address": "8230 Culebra Rd, San Antonio, TX 78251, USA",
      "poi_short_description": "Butcher shop supplying a range of meat for cooking and grilling, and also selling tacos.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1506-b4e0-72b9-8a90-405b77a8cd4c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-b4e0-72b9-8a90-405b77a8cd4c",
        "storage_key": "property/5174477956579328/019f1506-b4e0-72b9-8a90-405b77a8cd4c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://culebrasupermarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1651965198035196671&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "culebra-meat-market-17",
      "poi_latitude": "29.4676017",
      "poi_longitude": "-98.6488436",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 210-680-9935",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26d1-75ba-b995-17c7cf51bbef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26d1-75ba-b995-17c7cf51bbef",
        "storage_key": "property/5174477956579328/019f1504-26d1-75ba-b995-17c7cf51bbef.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ4zXn-SVdXIYR_xoyWpj17BY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "butcher_shop"
    },
    {
      "id": "ec_e22f8325efe409ea4756e020",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Love Shack Boutique",
      "poi_type": "Shopping & Retail",
      "poi_address": "10038 Potranco Rd #105, San Antonio, TX 78251, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1506-b65f-707e-a686-8455ad9d3f66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-b65f-707e-a686-8455ad9d3f66",
        "storage_key": "property/5174477956579328/019f1506-b65f-707e-a686-8455ad9d3f66.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "https://www.theloveshackboutique.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4559184760151095856&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "love-shack-boutique",
      "poi_latitude": "29.4347998",
      "poi_longitude": "-98.6896723",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 210-689-3037",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26d1-75ba-b995-17c7cf51bbef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26d1-75ba-b995-17c7cf51bbef",
        "storage_key": "property/5174477956579328/019f1504-26d1-75ba-b995-17c7cf51bbef.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJFa1QgmNDXIYRMDouPmJ6RT8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "womens_clothing_store"
    },
    {
      "id": "ec_f65eaf278ca7f4bb43b16ce6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Carlos Coon Elementary School",
      "poi_type": "Education",
      "poi_address": "3110 Timber View Dr, San Antonio, TX 78251, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://nisd.net/carloscoon/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3340777228021753165&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carlos-coon-elementary-school",
      "poi_latitude": "29.465261",
      "poi_longitude": "-98.652023",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 210-397-7250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26f8-71e0-bc16-eabd3e3e79a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26f8-71e0-bc16-eabd3e3e79a5",
        "storage_key": "property/5174477956579328/019f1504-26f8-71e0-bc16-eabd3e3e79a5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3QJy5ChdXIYRTWXzTTDTXC4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_da8191bb87f36cb64228e756",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Little Leaps Academy",
      "poi_type": "Education",
      "poi_address": "7919 Pipers Ln, San Antonio, TX 78251, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1506-b6d8-7726-8633-df9e212e87f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-b6d8-7726-8633-df9e212e87f8",
        "storage_key": "property/5174477956579328/019f1506-b6d8-7726-8633-df9e212e87f8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.littleleapsacademy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15965122231459980852&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "little-leaps-academy",
      "poi_latitude": "29.46773",
      "poi_longitude": "-98.646125",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 210-520-3935",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26f8-71e0-bc16-eabd3e3e79a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26f8-71e0-bc16-eabd3e3e79a5",
        "storage_key": "property/5174477956579328/019f1504-26f8-71e0-bc16-eabd3e3e79a5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQcyhLSRdXIYRNCbdKRWCj90",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_49023037a44efce0d01b0352",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Virginia A. Myers Elementary School",
      "poi_type": "Education",
      "poi_address": "3031 Village Pkwy, San Antonio, TX 78251, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://nisd.net/myers/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1881164850158928747&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "virginia-a-myers-elementary-school",
      "poi_latitude": "29.4720179",
      "poi_longitude": "-98.6545473",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 210-397-6650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26f8-71e0-bc16-eabd3e3e79a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26f8-71e0-bc16-eabd3e3e79a5",
        "storage_key": "property/5174477956579328/019f1504-26f8-71e0-bc16-eabd3e3e79a5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJqVMT189CXIYRa4Os4XY9Gxo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_4ab008439e4396176ef82690",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Dr. Winn Murnin Elementary School",
      "poi_type": "Education",
      "poi_address": "9019 Dugas Rd, San Antonio, TX 78251, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://nisd.net/murnin/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5221383316418606790&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dr-winn-murnin-elementary-school",
      "poi_latitude": "29.4437",
      "poi_longitude": "-98.6843866",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 210-397-4550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26f8-71e0-bc16-eabd3e3e79a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26f8-71e0-bc16-eabd3e3e79a5",
        "storage_key": "property/5174477956579328/019f1504-26f8-71e0-bc16-eabd3e3e79a5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJc-QEQxZDXIYRxjZIU3YUdkg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_35241da6b75d77cc4f93791d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Carl and Bunny Jean Raba Elementary School",
      "poi_type": "Education",
      "poi_address": "9740 Raba Dr, San Antonio, TX 78251, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1506-bcaa-719d-b807-c51e65498cd1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-bcaa-719d-b807-c51e65498cd1",
        "storage_key": "property/5174477956579328/019f1506-bcaa-719d-b807-c51e65498cd1.webp",
        "width": 615,
        "height": 320
      },
      "poi_business_url": "https://nisd.net/raba/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10377723646365044030&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carl-and-bunny-jean-raba-elementary-school",
      "poi_latitude": "29.4695997",
      "poi_longitude": "-98.6689642",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 210-397-1350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26f8-71e0-bc16-eabd3e3e79a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26f8-71e0-bc16-eabd3e3e79a5",
        "storage_key": "property/5174477956579328/019f1504-26f8-71e0-bc16-eabd3e3e79a5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJuY5qrdFCXIYRPo3CPqwUBZA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_8caa0753496d34bab5912d56",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Jack C. Jordan Middle School",
      "poi_type": "Education",
      "poi_address": "1725 Richland Hills Dr, San Antonio, TX 78251, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1506-bea3-750a-9508-c35a6fafcf01.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-bea3-750a-9508-c35a6fafcf01",
        "storage_key": "property/5174477956579328/019f1506-bea3-750a-9508-c35a6fafcf01.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.nisd.net/jordan",
      "poi_directions_map_url": "https://maps.google.com/?cid=12878943552622811384&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jack-c-jordan-middle-school",
      "poi_latitude": "29.4573423",
      "poi_longitude": "-98.6675361",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 210-397-6150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26f8-71e0-bc16-eabd3e3e79a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26f8-71e0-bc16-eabd3e3e79a5",
        "storage_key": "property/5174477956579328/019f1504-26f8-71e0-bc16-eabd3e3e79a5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJmSxynilDXIYR-Nhj8Owyu7I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_1f7470e9c072fe0b1be8d6e0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Pat M Neff Middle School",
      "poi_type": "Education",
      "poi_address": "5227 Evers Rd, San Antonio, TX 78238, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.nisd.net/neff",
      "poi_directions_map_url": "https://maps.google.com/?cid=13261175079205157984&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pat-m-neff-middle-school",
      "poi_latitude": "29.4835162",
      "poi_longitude": "-98.5900322",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 210-397-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26f8-71e0-bc16-eabd3e3e79a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26f8-71e0-bc16-eabd3e3e79a5",
        "storage_key": "property/5174477956579328/019f1504-26f8-71e0-bc16-eabd3e3e79a5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ9W2_ssZdXIYRYDxJTHkoCbg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_95c41a6aff054c9e8e5cafdc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Earl Warren High School",
      "poi_type": "Education",
      "poi_address": "9411 Military Dr W, San Antonio, TX 78251, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1506-c97f-701e-babc-01788f48f66f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-c97f-701e-babc-01788f48f66f",
        "storage_key": "property/5174477956579328/019f1506-c97f-701e-babc-01788f48f66f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://nisd.net/warren/",
      "poi_directions_map_url": "https://maps.google.com/?cid=914023558998593264&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "earl-warren-high-school",
      "poi_latitude": "29.4636506",
      "poi_longitude": "-98.6701148",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 210-397-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26f8-71e0-bc16-eabd3e3e79a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26f8-71e0-bc16-eabd3e3e79a5",
        "storage_key": "property/5174477956579328/019f1504-26f8-71e0-bc16-eabd3e3e79a5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIwisbddCXIYR8A5zjpVDrww",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_036161b19b53eba59f338b36",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Northwest Vista College",
      "poi_type": "Education",
      "poi_address": "3535 N Ellison Dr, San Antonio, TX 78251, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1503-e369-72fb-95b1-38887ed27524.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-e369-72fb-95b1-38887ed27524",
        "storage_key": "property/5174477956579328/019f1503-e369-72fb-95b1-38887ed27524.webp",
        "width": 1137,
        "height": 640
      },
      "poi_business_url": "https://www.alamo.edu/nvc/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17417931226689792052&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northwest-vista-college",
      "poi_latitude": "29.4716439",
      "poi_longitude": "-98.705443",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 210-486-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26f8-71e0-bc16-eabd3e3e79a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26f8-71e0-bc16-eabd3e3e79a5",
        "storage_key": "property/5174477956579328/019f1504-26f8-71e0-bc16-eabd3e3e79a5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJO8IBBVpCXIYRNGgHoSrsuPE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_e51507d71143c576fa5040a4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Northeast Lakeview College",
      "poi_type": "Education",
      "poi_address": "1201 Kitty Hawk Rd, Universal City, TX 78148, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1506-c677-7297-80aa-769d43257916.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-c677-7297-80aa-769d43257916",
        "storage_key": "property/5174477956579328/019f1506-c677-7297-80aa-769d43257916.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.alamo.edu/nlc/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14043398872120262215&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northeast-lakeview-college",
      "poi_latitude": "29.5468482",
      "poi_longitude": "-98.3238595",
      "poi_miles_from_property": "24.6 mi",
      "poi_walking_minutes": "9 hours 11 mins",
      "poi_biking_minutes": "2 hours 29 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "+1 210-212-5266",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26f8-71e0-bc16-eabd3e3e79a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26f8-71e0-bc16-eabd3e3e79a5",
        "storage_key": "property/5174477956579328/019f1504-26f8-71e0-bc16-eabd3e3e79a5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ329YvESNXIYRR37Ze94s5MI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_f19b68446cbdc13b19e8a42e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "SeaWorld San Antonio",
      "poi_type": "Entertainment",
      "poi_address": "10500 SeaWorld Dr, San Antonio, TX 78251, USA",
      "poi_short_description": "Marine life shows, thrill rides, aquariums & up-close encounters with dolphins, penguins & more.",
      "poi_long_description": "Marine life shows, thrill rides, aquariums & up-close encounters with dolphins, penguins & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1503-e861-7243-a394-41fdf2cbb657.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-e861-7243-a394-41fdf2cbb657",
        "storage_key": "property/5174477956579328/019f1503-e861-7243-a394-41fdf2cbb657.webp",
        "width": 1280,
        "height": 952
      },
      "poi_business_url": "https://seaworld.com/san-antonio?utm_source=google&utm_medium=organic&utm_campaign=gbp_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=8854466051154083971&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seaworld-san-antonio",
      "poi_latitude": "29.4562822",
      "poi_longitude": "-98.6999612",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 210-520-4732",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26d4-764c-aab6-380cb77612fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26d4-764c-aab6-380cb77612fb",
        "storage_key": "property/5174477956579328/019f1504-26d4-764c-aab6-380cb77612fb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc9c70gFDXIYRg4DL5vVh4Xo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_940e1ffac110066926c6e664",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Topgolf San Antonio",
      "poi_type": "Entertainment",
      "poi_address": "5539 N Loop 1604 W, San Antonio, TX 78249, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1506-c424-768e-b3f4-a75cf0b1ba23.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-c424-768e-b3f4-a75cf0b1ba23",
        "storage_key": "property/5174477956579328/019f1506-c424-768e-b3f4-a75cf0b1ba23.webp",
        "width": 800,
        "height": 525
      },
      "poi_business_url": "https://topgolf.com/us/san-antonio/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18114592869921636103&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "topgolf-san-antonio",
      "poi_latitude": "29.5940894",
      "poi_longitude": "-98.5950414",
      "poi_miles_from_property": "12.8 mi",
      "poi_walking_minutes": "4 hours 42 mins",
      "poi_biking_minutes": "1 hour 23 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 210-202-2694",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26d2-7343-b6be-1047ee9dba96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26d2-7343-b6be-1047ee9dba96",
        "storage_key": "property/5174477956579328/019f1504-26d2-7343-b6be-1047ee9dba96.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJVZ8Xo5hmXIYRB7-Abj32Y_s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_2b669a2cf86fd61ef779391b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Santikos Silverado",
      "poi_type": "Entertainment",
      "poi_address": "11505 W Loop 1604 N, San Antonio, TX 78250, USA",
      "poi_short_description": "Upscale movie theater with a full food & drink menu, plus table seating & wait service.",
      "poi_long_description": "Upscale movie theater with a full food & drink menu, plus table seating & wait service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1506-cb80-7302-a825-a7ec5cf25561.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-cb80-7302-a825-a7ec5cf25561",
        "storage_key": "property/5174477956579328/019f1506-cb80-7302-a825-a7ec5cf25561.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.santikos.com/san-antonio/silverado/theater-info/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5927242804627298741&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "santikos-silverado",
      "poi_latitude": "29.5521118",
      "poi_longitude": "-98.6716162",
      "poi_miles_from_property": "7.5 mi",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 877-691-0734",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1507-3697-74bc-a976-6cd042999ef6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1507-3697-74bc-a976-6cd042999ef6",
        "storage_key": "property/5174477956579328/019f1507-3697-74bc-a976-6cd042999ef6.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJs-mrCX9eXIYRtdlMS-3LQVI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_a6482e6266472fbd679e1e35",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Alamo Drafthouse Cinema Park North",
      "poi_type": "Entertainment",
      "poi_address": "618 Northwest Loop 410 Suite 307, San Antonio, TX 78216, USA",
      "poi_short_description": "Stylish theater chain for new & classic films features cocktails & creative bites served seat-side.",
      "poi_long_description": "Stylish theater chain for new & classic films features cocktails & creative bites served seat-side.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1506-cdf9-764f-9d87-0fc147383f3e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-cdf9-764f-9d87-0fc147383f3e",
        "storage_key": "property/5174477956579328/019f1506-cdf9-764f-9d87-0fc147383f3e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://drafthouse.com/san-antonio/theater/park-north",
      "poi_directions_map_url": "https://maps.google.com/?cid=4896953682073721197&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alamo-drafthouse-cinema-park-north",
      "poi_latitude": "29.5184914",
      "poi_longitude": "-98.5029124",
      "poi_miles_from_property": "11.9 mi",
      "poi_walking_minutes": "4 hours 27 mins",
      "poi_biking_minutes": "1 hour 15 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 210-729-9293",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1507-3697-74bc-a976-6cd042999ef6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1507-3697-74bc-a976-6cd042999ef6",
        "storage_key": "property/5174477956579328/019f1507-3697-74bc-a976-6cd042999ef6.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJfSoHzwtgXIYRbZmLvW159UM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_989fd1429b50dea2c2f5d084",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Alamo Quarry Market",
      "poi_type": "Entertainment",
      "poi_address": "255 E Basse Rd, San Antonio, TX 78209, USA",
      "poi_short_description": "Airy mall home to major apparel & homewares stores, eclectic eateries & a cinema amid a modern site.",
      "poi_long_description": "Airy mall home to major apparel & homewares stores, eclectic eateries & a cinema amid a modern site.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1506-dad6-77e4-b06a-4eb1f2eeb3fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-dad6-77e4-b06a-4eb1f2eeb3fb",
        "storage_key": "property/5174477956579328/019f1506-dad6-77e4-b06a-4eb1f2eeb3fb.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "http://quarrymarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4663225067816664189&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alamo-quarry-market",
      "poi_latitude": "29.4962615",
      "poi_longitude": "-98.4799046",
      "poi_miles_from_property": "12.8 mi",
      "poi_walking_minutes": "4 hours 47 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 210-824-8885",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26d1-75ba-b995-17c7cf51bbef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26d1-75ba-b995-17c7cf51bbef",
        "storage_key": "property/5174477956579328/019f1504-26d1-75ba-b995-17c7cf51bbef.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ7See-2D1XIYRfbzoCn4at0A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_3ce70a0c0750fa4222c3017a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "The DoSeum",
      "poi_type": "Entertainment",
      "poi_address": "2800 Broadway, San Antonio, TX 78209, USA",
      "poi_short_description": "2-story museum promoting learning & discovery through interactive exhibits & creative programs.",
      "poi_long_description": "2-story museum promoting learning & discovery through interactive exhibits & creative programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1506-d559-77f1-9fec-809ea4899300.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-d559-77f1-9fec-809ea4899300",
        "storage_key": "property/5174477956579328/019f1506-d559-77f1-9fec-809ea4899300.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://thedoseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15763963794875614826&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-doseum",
      "poi_latitude": "29.4533152",
      "poi_longitude": "-98.4716971",
      "poi_miles_from_property": "12.3 mi",
      "poi_walking_minutes": "4 hours 32 mins",
      "poi_biking_minutes": "1 hour 13 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 210-212-4453",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1507-3697-74bc-a976-6b7d687c6d57.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1507-3697-74bc-a976-6b7d687c6d57",
        "storage_key": "property/5174477956579328/019f1507-3697-74bc-a976-6b7d687c6d57.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJIVWnfJL1XIYRagau5YzZxNo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_bc89066edad62c6751ae92f6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Witte Museum",
      "poi_type": "Entertainment",
      "poi_address": "3801 Broadway, San Antonio, TX 78209, USA",
      "poi_short_description": "Touring & long-term exhibits about natural history, art & Texas heritage, plus a Science Treehouse.",
      "poi_long_description": "Touring & long-term exhibits about natural history, art & Texas heritage, plus a Science Treehouse.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1506-e350-753f-bb06-0b7df891cb60.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-e350-753f-bb06-0b7df891cb60",
        "storage_key": "property/5174477956579328/019f1506-e350-753f-bb06-0b7df891cb60.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.wittemuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14696973662473378755&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "witte-museum",
      "poi_latitude": "29.46197799999999",
      "poi_longitude": "-98.4669496",
      "poi_miles_from_property": "12.5 mi",
      "poi_walking_minutes": "4 hours 38 mins",
      "poi_biking_minutes": "1 hour 15 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 210-357-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1507-3697-74bc-a976-6b7d687c6d57.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1507-3697-74bc-a976-6b7d687c6d57",
        "storage_key": "property/5174477956579328/019f1507-3697-74bc-a976-6b7d687c6d57.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8SkZWZf1XIYRw1v_mK0j9ss",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_3856041f1a50fa6a91e4c360",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "McNay Art Museum",
      "poi_type": "Entertainment",
      "poi_address": "6000 N New Braunfels Ave, San Antonio, TX 78209, USA",
      "poi_short_description": "American & European art (from Medieval to contemporary) in a 1929 mansion with a modern addition.",
      "poi_long_description": "American & European art (from Medieval to contemporary) in a 1929 mansion with a modern addition.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1506-cef6-7369-adab-50ca1e1a5fac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-cef6-7369-adab-50ca1e1a5fac",
        "storage_key": "property/5174477956579328/019f1506-cef6-7369-adab-50ca1e1a5fac.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "https://www.mcnayart.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=401667984493421393&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcnay-art-museum",
      "poi_latitude": "29.4856801",
      "poi_longitude": "-98.4570958",
      "poi_miles_from_property": "13.6 mi",
      "poi_walking_minutes": "5 hours 3 mins",
      "poi_biking_minutes": "1 hour 28 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 210-824-5368",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1507-3697-74bc-a976-6b7d687c6d57.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1507-3697-74bc-a976-6b7d687c6d57",
        "storage_key": "property/5174477956579328/019f1507-3697-74bc-a976-6b7d687c6d57.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJQzg3fxL1XIYRUaNgXecCkwU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_98597506985fc17118142966",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Six Flags Fiesta Texas",
      "poi_type": "Entertainment",
      "poi_address": "San Antonio, TX 78257, USA",
      "poi_short_description": "Part of an amusement park chain with roller coasters, rides, live shows, a water park, food & beer.",
      "poi_long_description": "Part of an amusement park chain with roller coasters, rides, live shows, a water park, food & beer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1506-e298-761f-ab88-b7feb693fed8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-e298-761f-ab88-b7feb693fed8",
        "storage_key": "property/5174477956579328/019f1506-e298-761f-ab88-b7feb693fed8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sixflags.com/fiestatexas?utm_source=googlebusinessprofile&utm_medium=organic&utm_campaign=Google+Business+Profile",
      "poi_directions_map_url": "https://maps.google.com/?cid=2548967654066146973&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "six-flags-fiesta-texas",
      "poi_latitude": "29.5993818",
      "poi_longitude": "-98.6088838",
      "poi_miles_from_property": "13.0 mi",
      "poi_walking_minutes": "4 hours 51 mins",
      "poi_biking_minutes": "1 hour 26 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 210-697-5050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26d4-764c-aab6-380cb77612fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26d4-764c-aab6-380cb77612fb",
        "storage_key": "property/5174477956579328/019f1504-26d4-764c-aab6-380cb77612fb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN55XmxZlXIYRnc6SjJPAXyM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_c3568921555686b4bce2d4c5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Morgan's Wonderland",
      "poi_type": "Entertainment",
      "poi_address": "5223 David Edwards Dr, San Antonio, TX 78233, USA",
      "poi_short_description": "Amusement center with acres of themed areas, rides & attractions for individuals with special needs.",
      "poi_long_description": "Amusement center with acres of themed areas, rides & attractions for individuals with special needs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1506-e748-731b-99c9-86cbef103903.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-e748-731b-99c9-86cbef103903",
        "storage_key": "property/5174477956579328/019f1506-e748-731b-99c9-86cbef103903.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.morganswonderland.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13026522371191900116&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "morgans-wonderland",
      "poi_latitude": "29.5391049",
      "poi_longitude": "-98.3926044",
      "poi_miles_from_property": "19.6 mi",
      "poi_walking_minutes": "7 hours 21 mins",
      "poi_biking_minutes": "2 hours 9 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 210-495-5888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26d4-764c-aab6-380cb77612fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26d4-764c-aab6-380cb77612fb",
        "storage_key": "property/5174477956579328/019f1504-26d4-764c-aab6-380cb77612fb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXQ1t26aMXIYR1IeSQRSBx7Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_12f669cee02dd2bb459c2aa2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "CHRISTUS Santa Rosa Hospital - Westover Hills",
      "poi_type": "Health and Wellness",
      "poi_address": "11212 TX-151, San Antonio, TX 78251, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1506-e288-748c-952f-6d161e32e683.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-e288-748c-952f-6d161e32e683",
        "storage_key": "property/5174477956579328/019f1506-e288-748c-952f-6d161e32e683.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.christushealth.org/locations/santa-rosa-hospital-westover-hills?utm_source=GBP&utm_medium=organic&utm_campaign=GBP-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=8125338576440180701&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "christus-santa-rosa-hospital---westover-hills",
      "poi_latitude": "29.4661178",
      "poi_longitude": "-98.6966164",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 210-703-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26d4-764c-aab6-3dd634ae8abb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26d4-764c-aab6-3dd634ae8abb",
        "storage_key": "property/5174477956579328/019f1504-26d4-764c-aab6-3dd634ae8abb.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJPX3uUvpCXIYR3b9-qGIAw3A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_97103770e7b420d25b2589e4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Next Level Urgent Care - Grandview",
      "poi_type": "Health and Wellness",
      "poi_address": "11034 Military Dr W, San Antonio, TX 78251, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1506-ddd4-7278-b8b2-515787de013d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-ddd4-7278-b8b2-515787de013d",
        "storage_key": "property/5174477956579328/019f1506-ddd4-7278-b8b2-515787de013d.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.nextlevelurgentcare.com/locations/grandview/?utm_source=gbp&utm_medium=organic&utm_campaign=grandview",
      "poi_directions_map_url": "https://maps.google.com/?cid=1916300837605367762&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "next-level-urgent-care---grandview",
      "poi_latitude": "29.4474484",
      "poi_longitude": "-98.7094499",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 726-465-7811",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26d4-764c-aab6-380cb77612fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26d4-764c-aab6-380cb77612fb",
        "storage_key": "property/5174477956579328/019f1504-26d4-764c-aab6-380cb77612fb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPbnu8HNDXIYR0l9AdHURmBo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_fcdaaef4ce435b85a322a6e9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "CareNow Urgent Care - Potranco",
      "poi_type": "Health and Wellness",
      "poi_address": "10538 Potranco Rd Bldg 1, San Antonio, TX 78251, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1506-ddf4-7457-b8c0-171d76faa9c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-ddf4-7457-b8c0-171d76faa9c4",
        "storage_key": "property/5174477956579328/019f1506-ddf4-7457-b8c0-171d76faa9c4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.carenow.com/locations/san-antonio/potranco?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=13901006030391210064&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carenow-urgent-care---potranco",
      "poi_latitude": "29.4349117",
      "poi_longitude": "-98.6989585",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 210-890-2640",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26d4-764c-aab6-380cb77612fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26d4-764c-aab6-380cb77612fb",
        "storage_key": "property/5174477956579328/019f1504-26d4-764c-aab6-380cb77612fb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJM9VCxhtDXIYRUPAHflVL6sA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_aa8d7635efe05374a72e43e0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Fast Aid Urgent Care (Hunt Lane) - 151",
      "poi_type": "Health and Wellness",
      "poi_address": "9230 Potranco Rd #108, San Antonio, TX 78251, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1506-e062-7364-856b-968d1a1fdc10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-e062-7364-856b-968d1a1fdc10",
        "storage_key": "property/5174477956579328/019f1506-e062-7364-856b-968d1a1fdc10.webp",
        "width": 803,
        "height": 469
      },
      "poi_business_url": "https://www.fastaiduc.com/locations-potranco",
      "poi_directions_map_url": "https://maps.google.com/?cid=4236165731630761707&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fast-aid-urgent-care-hunt-lane---151",
      "poi_latitude": "29.4412531",
      "poi_longitude": "-98.6666336",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 210-660-3114",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26d4-764c-aab6-380cb77612fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26d4-764c-aab6-380cb77612fb",
        "storage_key": "property/5174477956579328/019f1504-26d4-764c-aab6-380cb77612fb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNQs_0VBDXIYR68aI60niyTo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_5e0b6bf49d6a8c7b375e590e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "8202 Culebra Rd, San Antonio, TX 78251, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1506-ee54-779c-a6ab-4a05a83d6468.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-ee54-779c-a6ab-4a05a83d6468",
        "storage_key": "property/5174477956579328/019f1506-ee54-779c-a6ab-4a05a83d6468.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-8202+culebra+rd-san+antonio-tx-78251/id=3734",
      "poi_directions_map_url": "https://maps.google.com/?cid=2935974809310772457&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "29.4666152",
      "poi_longitude": "-98.6478268",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 210-543-8419",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26d4-764c-aab6-380cb77612fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26d4-764c-aab6-380cb77612fb",
        "storage_key": "property/5174477956579328/019f1504-26d4-764c-aab6-380cb77612fb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjUL4dCZdXIYR6bx2moitvig",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_55b6e6d7b23c514bde8ebd7d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "CVS Pharmacy y más",
      "poi_type": "Health and Wellness",
      "poi_address": "7603 Culebra Rd, San Antonio, TX 78251, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1506-b216-74ac-bec9-a6b09070bee3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-b216-74ac-bec9-a6b09070bee3",
        "storage_key": "property/5174477956579328/019f1506-b216-74ac-bec9-a6b09070bee3.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/san-antonio-tx-pharmacies/7603-culebra-san-antonio-tx-78251/storeid=5857?WT.mc_id=LS_GOOGLE_RX_5857",
      "poi_directions_map_url": "https://maps.google.com/?cid=13911038483388103728&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy-y-ms",
      "poi_latitude": "29.4597861",
      "poi_longitude": "-98.6383176",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-680-0299",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1507-367e-7233-a886-b6337dade2fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1507-367e-7233-a886-b6337dade2fc",
        "storage_key": "property/5174477956579328/019f1507-367e-7233-a886-b6337dade2fc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvceW2d9cXIYRMPwi-8vvDcE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_0609f3db37c23c43dee5d9aa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "H-E-B Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "10718 Potranco Rd, San Antonio, TX 78251, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1506-ed41-722d-a64a-165d4e004fe6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-ed41-722d-a64a-165d4e004fe6",
        "storage_key": "property/5174477956579328/019f1506-ed41-722d-a64a-165d4e004fe6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.heb.com/pharmacy/common/landing?utm_source=google&utm_medium=organic&utm_campaign=gmb_pharmacy",
      "poi_directions_map_url": "https://maps.google.com/?cid=5719295874393773660&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b-pharmacy",
      "poi_latitude": "29.433548",
      "poi_longitude": "-98.703546",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 210-681-2301",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1507-367e-7233-a886-b6337dade2fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1507-367e-7233-a886-b6337dade2fc",
        "storage_key": "property/5174477956579328/019f1507-367e-7233-a886-b6337dade2fc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOePYuwpDXIYRXBaZrksFX08",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_5396909c023cee4177504e75",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "11227 Potranco Rd, San Antonio, TX 78253, USA",
      "poi_short_description": "Chain gym with a variety of cardio equipment and tanning options, plus massage chairs.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1503-f54c-71ef-b313-9bba80863422.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-f54c-71ef-b313-9bba80863422",
        "storage_key": "property/5174477956579328/019f1503-f54c-71ef-b313-9bba80863422.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/san-antonio-potranco-tx?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=14458905044375652698&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "29.4367219",
      "poi_longitude": "-98.7150683",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 210-679-9999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26d4-764c-aab6-380cb77612fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26d4-764c-aab6-380cb77612fb",
        "storage_key": "property/5174477956579328/019f1504-26d4-764c-aab6-380cb77612fb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm1KVRL1DXIYRWkkdA4hZqMg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_852c5ded3590626f806d778e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Gold's Gym San Antonio Legacy Trails",
      "poi_type": "Health and Wellness",
      "poi_address": "8935 TX-151, San Antonio, TX 78251, USA",
      "poi_short_description": "Chain gym with weights, cardio machines, a pool, and a basketball court, plus personal trainers.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1506-fb9b-74ab-972f-7d4cfc5c4361.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-fb9b-74ab-972f-7d4cfc5c4361",
        "storage_key": "property/5174477956579328/019f1506-fb9b-74ab-972f-7d4cfc5c4361.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "https://www.goldsgym.com/san-antonio-legacy-trails/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16799450280936354292&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "golds-gym-san-antonio-legacy-trails",
      "poi_latitude": "29.44549659999999",
      "poi_longitude": "-98.6647458",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 210-200-6160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26d4-764c-aab6-380cb77612fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26d4-764c-aab6-380cb77612fb",
        "storage_key": "property/5174477956579328/019f1504-26d4-764c-aab6-380cb77612fb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7eCyyMpcXIYR9DEM8QWjI-k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_0df032d64bb96bfd9fae9f41",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Mays Family YMCA at Potranco",
      "poi_type": "Health and Wellness",
      "poi_address": "8765 Texas 151 Access Rd, San Antonio, TX 78245, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1506-edef-724f-ac4c-9ea0c40db906.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-edef-724f-ac4c-9ea0c40db906",
        "storage_key": "property/5174477956579328/019f1506-edef-724f-ac4c-9ea0c40db906.webp",
        "width": 1280,
        "height": 599
      },
      "poi_business_url": "http://www.ymcasatx.org/MaysatPotranco",
      "poi_directions_map_url": "https://maps.google.com/?cid=16295184334921628512&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mays-family-ymca-at-potranco",
      "poi_latitude": "29.4422474",
      "poi_longitude": "-98.660978",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 210-901-6622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26d4-764c-aab6-380cb77612fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26d4-764c-aab6-380cb77612fb",
        "storage_key": "property/5174477956579328/019f1504-26d4-764c-aab6-380cb77612fb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh2pKljRDXIYRYHuDKNEfJOI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "ec_8d4cd0e57a0db81b024a1c89",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Timber Ridge Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3103 Rim Rock Trail, San Antonio, TX 78251, USA",
      "poi_short_description": "Park with a cushioned walking track, basketball court, playground, and gazebo.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1506-fa7d-7119-9a47-fa067ccb18b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-fa7d-7119-9a47-fa067ccb18b5",
        "storage_key": "property/5174477956579328/019f1506-fa7d-7119-9a47-fa067ccb18b5.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.sa.gov/Directory/Departments/Parks/Parks-Facilities/Parks/Directory/Timber-Ridge-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=5390885329889614239&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "timber-ridge-park",
      "poi_latitude": "29.4689669",
      "poi_longitude": "-98.6540498",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 210-207-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26eb-73fc-b57e-8428048489d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26eb-73fc-b57e-8428048489d5",
        "storage_key": "property/5174477956579328/019f1504-26eb-73fc-b57e-8428048489d5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ79QX2xJdXIYRn1nvOKVF0Eo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_57242d2f4f0cd8bf93886572",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Grissom Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7379 Grissom Rd, San Antonio, TX 78251, USA",
      "poi_short_description": "Paved trail with views of the area, plus markers for distance.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1506-f81e-774f-b71d-2bef16bb0401.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-f81e-774f-b71d-2bef16bb0401",
        "storage_key": "property/5174477956579328/019f1506-f81e-774f-b71d-2bef16bb0401.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.sanantonio.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7084619304546987356&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grissom-trailhead",
      "poi_latitude": "29.4826749",
      "poi_longitude": "-98.6330002",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-207-8480",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26eb-73fc-b57e-8428048489d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26eb-73fc-b57e-8428048489d5",
        "storage_key": "property/5174477956579328/019f1504-26eb-73fc-b57e-8428048489d5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJh11PhhRdXIYRXO1luLifUWI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_6108ad95950294cdb221b31b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Cathedral Rock Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8002 Grissom Rd, San Antonio, TX 78251, USA",
      "poi_short_description": "Leafy local park with cycling & walking trails, play equipment, a pavilion & picnic tables.",
      "poi_long_description": "Leafy local park with cycling & walking trails, play equipment, a pavilion & picnic tables.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-1a87-70a2-bd6d-98fd0a59ea04.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-1a87-70a2-bd6d-98fd0a59ea04",
        "storage_key": "property/5174477956579328/019f1504-1a87-70a2-bd6d-98fd0a59ea04.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.sanantonio.gov/ParksAndRec/Parks-Facilities/All-Parks-Facilities/Parks-Facilities-Details/ArtMID/14820/ArticleID/2443/Cathedral-Rock-Park?Park=34&Facility=",
      "poi_directions_map_url": "https://maps.google.com/?cid=3192952255958149799&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cathedral-rock-park",
      "poi_latitude": "29.4772582",
      "poi_longitude": "-98.6453105",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-207-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26eb-73fc-b57e-8428048489d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26eb-73fc-b57e-8428048489d5",
        "storage_key": "property/5174477956579328/019f1504-26eb-73fc-b57e-8428048489d5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-W-DtztdXIYRp-oq6SilTyw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_2e479f099430d9350d91ad8a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Culebra Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10919 Westwood Loop, San Antonio, TX 78254, USA",
      "poi_short_description": "Roughly 145 acres boasting grassy & wooded areas, a walking trail & multipurpose sport fields.",
      "poi_long_description": "Roughly 145 acres boasting grassy & wooded areas, a walking trail & multipurpose sport fields.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1507-0159-759a-b29c-e716c5146abb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1507-0159-759a-b29c-e716c5146abb",
        "storage_key": "property/5174477956579328/019f1507-0159-759a-b29c-e716c5146abb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sa.gov/Directory/Departments/Parks/Parks-Facilities/Parks/Directory/Culebra-Creek-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=11012182010559695994&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "culebra-creek-park",
      "poi_latitude": "29.4983731",
      "poi_longitude": "-98.7088968",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 210-207-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26eb-73fc-b57e-8428048489d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26eb-73fc-b57e-8428048489d5",
        "storage_key": "property/5174477956579328/019f1504-26eb-73fc-b57e-8428048489d5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJJWly9nhCXIYReoxbjTEh05g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_db0312243b27e39a9f0be99a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Buddy Calk Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6934 Babcock Rd, San Antonio, TX 78249, USA",
      "poi_short_description": "Popular park with paved trails, playgrounds and a creek, plus mountain-bike paths, for wildlife viewing .",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1507-0ba5-749d-8a12-a8fc71defd47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1507-0ba5-749d-8a12-a8fc71defd47",
        "storage_key": "property/5174477956579328/019f1507-0ba5-749d-8a12-a8fc71defd47.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.sanantonio.gov/GreenwayTrails",
      "poi_directions_map_url": "https://maps.google.com/?cid=10203707128741324386&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "buddy-calk-trailhead",
      "poi_latitude": "29.5568877",
      "poi_longitude": "-98.6267101",
      "poi_miles_from_property": "8.5 mi",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26eb-73fc-b57e-8428048489d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26eb-73fc-b57e-8428048489d5",
        "storage_key": "property/5174477956579328/019f1504-26eb-73fc-b57e-8428048489d5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJwaWphFJmXIYRYma_cJLZmo0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_a512631196017facfc217b92",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Tom Slick Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7400 Texas 151 Access Rd, San Antonio, TX 78227, USA",
      "poi_short_description": "Suburban park with a 1-acre dog area, pond & baseball, football & soccer fields & pavilion for hire.",
      "poi_long_description": "Suburban park with a 1-acre dog area, pond & baseball, football & soccer fields & pavilion for hire.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1507-073a-757d-a0eb-58680e74f5bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1507-073a-757d-a0eb-58680e74f5bb",
        "storage_key": "property/5174477956579328/019f1507-073a-757d-a0eb-58680e74f5bb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.sanantonio.gov/ParksAndRec/Parks-Facilities/All-Parks-Facilities/Parks-Facilities-Details/ArtMID/14820/ArticleID/2493/Slick-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=4013846829374659664&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tom-slick-park",
      "poi_latitude": "29.4304963",
      "poi_longitude": "-98.6347818",
      "poi_miles_from_property": "7.1 mi",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 210-207-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26eb-73fc-b57e-8428048489d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26eb-73fc-b57e-8428048489d5",
        "storage_key": "property/5174477956579328/019f1504-26eb-73fc-b57e-8428048489d5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJETeE8pZcXIYRUFy0z2wMtDc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_6ff7a8676efc08fe211ef47a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "McAllister Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "13102 Jones Maltsberger Rd, San Antonio, TX 78247, USA",
      "poi_short_description": "Natural area with jogging & biking trails, picnic spots, a dog park, playscapes & athletic fields.",
      "poi_long_description": "Natural area with jogging & biking trails, picnic spots, a dog park, playscapes & athletic fields.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1507-03b9-71aa-bf2d-28e027e3d218.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1507-03b9-71aa-bf2d-28e027e3d218",
        "storage_key": "property/5174477956579328/019f1507-03b9-71aa-bf2d-28e027e3d218.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.sanantonio.gov/ParksAndRec/Parks-Facilities/All-Parks-Facilities/Parks-Facilities-Details/ArtMID/14820/ArticleID/2578/McAllister-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=1871900702508716191&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcallister-park",
      "poi_latitude": "29.563045",
      "poi_longitude": "-98.4542279",
      "poi_miles_from_property": "17.3 mi",
      "poi_walking_minutes": "6 hours 28 mins",
      "poi_biking_minutes": "2 hours 6 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 210-207-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26eb-73fc-b57e-8428048489d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26eb-73fc-b57e-8428048489d5",
        "storage_key": "property/5174477956579328/019f1504-26eb-73fc-b57e-8428048489d5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJJa-WcPyKXIYRnxDWa8VT-hk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_b491d184ca51416ce99fb025",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Government Canyon State Natural Area",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12861 Galm Rd, San Antonio, TX 78254, USA",
      "poi_short_description": "Tranquil park featuring multi-use trails from rugged to beginner-friendly, plus guided canyon hikes.",
      "poi_long_description": "Tranquil park featuring multi-use trails from rugged to beginner-friendly, plus guided canyon hikes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1507-0b37-7239-8533-b8265e56325f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1507-0b37-7239-8533-b8265e56325f",
        "storage_key": "property/5174477956579328/019f1507-0b37-7239-8533-b8265e56325f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://tpwd.texas.gov/state-parks/government-canyon",
      "poi_directions_map_url": "https://maps.google.com/?cid=11615951085383130630&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "government-canyon-state-natural-area",
      "poi_latitude": "29.549356",
      "poi_longitude": "-98.764798",
      "poi_miles_from_property": "10.4 mi",
      "poi_walking_minutes": "3 hours 51 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 210-688-9055",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26eb-73fc-b57e-8428048489d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26eb-73fc-b57e-8428048489d5",
        "storage_key": "property/5174477956579328/019f1504-26eb-73fc-b57e-8428048489d5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJMWz1--NrXIYRBh6T3PclNKE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "ec_321b9e962720c3cc63840744",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Stone Oak Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "San Antonio, TX 78258, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1507-0ae2-7548-9b44-0ef5911d7d46.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1507-0ae2-7548-9b44-0ef5911d7d46",
        "storage_key": "property/5174477956579328/019f1507-0ae2-7548-9b44-0ef5911d7d46.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2799189516933231610&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stone-oak-park--ride",
      "poi_latitude": "29.6477433",
      "poi_longitude": "-98.4523872",
      "poi_miles_from_property": "20.1 mi",
      "poi_walking_minutes": "7 hours 38 mins",
      "poi_biking_minutes": "2 hours 12 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26d4-764c-aab6-380cb77612fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26d4-764c-aab6-380cb77612fb",
        "storage_key": "property/5174477956579328/019f1504-26d4-764c-aab6-380cb77612fb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDf2VPbCJXIYR-nPN7wi42CY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_5436027cf4fe4f1354a39c1a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "VIA Crossroads Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "151 N Crossroads Blvd, Balcones Heights, TX 78201, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1507-1373-75d2-994b-01903a78b14c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1507-1373-75d2-994b-01903a78b14c",
        "storage_key": "property/5174477956579328/019f1507-1373-75d2-994b-01903a78b14c.webp",
        "width": 1280,
        "height": 577
      },
      "poi_business_url": "http://viainfo.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14912817806174523366&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "via-crossroads-park--ride",
      "poi_latitude": "29.493575",
      "poi_longitude": "-98.5483679",
      "poi_miles_from_property": "7.5 mi",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 210-362-2892",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1507-36e4-7494-a3e2-d6c2015910d7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1507-36e4-7494-a3e2-d6c2015910d7",
        "storage_key": "property/5174477956579328/019f1507-36e4-7494-a3e2-d6c2015910d7.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJNXQTzYRfXIYR5g8ngcj49M4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_af3f07b4e961786956817ba1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Randolph Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "9400 I-35, San Antonio, TX 78233, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1507-122d-738d-8d59-57fd449a791c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1507-122d-738d-8d59-57fd449a791c",
        "storage_key": "property/5174477956579328/019f1507-122d-738d-8d59-57fd449a791c.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12602308921134006725&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "randolph-park-and-ride",
      "poi_latitude": "29.5244671",
      "poi_longitude": "-98.3923536",
      "poi_miles_from_property": "19.5 mi",
      "poi_walking_minutes": "7 hours 17 mins",
      "poi_biking_minutes": "1 hour 57 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1507-36e4-7494-a3e2-d6c2015910d7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1507-36e4-7494-a3e2-d6c2015910d7",
        "storage_key": "property/5174477956579328/019f1507-36e4-7494-a3e2-d6c2015910d7.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJMct5BLKNXIYRxcHtoTFl5K4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_f4fb344bebdaa96debfba0b7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "North Star Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "7538 San Pedro Ave, San Antonio, TX 78216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1507-1300-743b-899a-8afa2416dcd2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1507-1300-743b-899a-8afa2416dcd2",
        "storage_key": "property/5174477956579328/019f1507-1300-743b-899a-8afa2416dcd2.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.viainfo.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10414624133700210677&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-star-transit-center",
      "poi_latitude": "29.51912",
      "poi_longitude": "-98.49871",
      "poi_miles_from_property": "12.1 mi",
      "poi_walking_minutes": "4 hours 33 mins",
      "poi_biking_minutes": "1 hour 20 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 210-409-7788",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26d4-764c-aab6-380cb77612fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26d4-764c-aab6-380cb77612fb",
        "storage_key": "property/5174477956579328/019f1504-26d4-764c-aab6-380cb77612fb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRbAqpAlgXIYR9U9pdngtiJA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_8c6f79830d8408aa530257fc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Ingram Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "3215 Northwestern Dr, San Antonio, TX 78238, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1507-1da6-771e-8cd6-00128e54f6d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1507-1da6-771e-8cd6-00128e54f6d7",
        "storage_key": "property/5174477956579328/019f1507-1da6-771e-8cd6-00128e54f6d7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.viainfo.net/transit-centers/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15286896482762599812&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ingram-transit-center",
      "poi_latitude": "29.4648153",
      "poi_longitude": "-98.6257608",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 210-521-6773",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26d4-764c-aab6-380cb77612fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26d4-764c-aab6-380cb77612fb",
        "storage_key": "property/5174477956579328/019f1504-26d4-764c-aab6-380cb77612fb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJryXVZVvZ-4YRhK07jVv3JdQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_3f59b633490de99360c6ad90",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Medical Center Transit Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "5330 Medical Dr, San Antonio, TX 78240, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1507-217b-724f-80c8-5b8b3e0900a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1507-217b-724f-80c8-5b8b3e0900a4",
        "storage_key": "property/5174477956579328/019f1507-217b-724f-80c8-5b8b3e0900a4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.viainfo.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17748660839738358253&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "medical-center-transit-station",
      "poi_latitude": "29.5076924",
      "poi_longitude": "-98.5896433",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 210-362-2896",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26d4-764c-aab6-380cb77612fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26d4-764c-aab6-380cb77612fb",
        "storage_key": "property/5174477956579328/019f1504-26d4-764c-aab6-380cb77612fb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJl0GJN_RdXIYR7bl9T__oT_Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_59732a0ab6828a07092bb213",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "VIA Centro Plaza",
      "poi_type": "Transportation & Transit",
      "poi_address": "909 W Houston St, San Antonio, TX 78207, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1507-18d3-70a0-8714-635e0a8c1f84.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1507-18d3-70a0-8714-635e0a8c1f84",
        "storage_key": "property/5174477956579328/019f1507-18d3-70a0-8714-635e0a8c1f84.webp",
        "width": 1280,
        "height": 724
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5120125305985227714&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "via-centro-plaza",
      "poi_latitude": "29.4272961",
      "poi_longitude": "-98.5041623",
      "poi_miles_from_property": "11.0 mi",
      "poi_walking_minutes": "4 hours 3 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 210-299-5802",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26d4-764c-aab6-380cb77612fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26d4-764c-aab6-380cb77612fb",
        "storage_key": "property/5174477956579328/019f1504-26d4-764c-aab6-380cb77612fb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAYhDWEpfXIYRwtu8lNZWDkc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_f7126bb7dfc763e15d0a447c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "VIA Brooks Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "7903 S New Braunfels Ave, San Antonio, TX 78223, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1507-1cb5-73f9-b636-e950ed099a62.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1507-1cb5-73f9-b636-e950ed099a62",
        "storage_key": "property/5174477956579328/019f1507-1cb5-73f9-b636-e950ed099a62.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.viainfo.net/brooks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15784373248118960708&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "via-brooks-transit-center",
      "poi_latitude": "29.34627979999999",
      "poi_longitude": "-98.4469207",
      "poi_miles_from_property": "18.5 mi",
      "poi_walking_minutes": "6 hours 47 mins",
      "poi_biking_minutes": "1 hour 38 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 210-362-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26d4-764c-aab6-380cb77612fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26d4-764c-aab6-380cb77612fb",
        "storage_key": "property/5174477956579328/019f1504-26d4-764c-aab6-380cb77612fb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8frkSIP3XIYRRDJPCNdbDds",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_727561e4a5fc709e6c5ab304",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Chestnut @ Ellis Alley Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "San Antonio, TX 78202, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1507-20af-756b-a386-e8c8983cf49c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1507-20af-756b-a386-e8c8983cf49c",
        "storage_key": "property/5174477956579328/019f1507-20af-756b-a386-e8c8983cf49c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=17942887006879847955&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chestnut--ellis-alley-park--ride",
      "poi_latitude": "29.423515",
      "poi_longitude": "-98.479719",
      "poi_miles_from_property": "12.4 mi",
      "poi_walking_minutes": "4 hours 35 mins",
      "poi_biking_minutes": "1 hour 9 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26d4-764c-aab6-380cb77612fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26d4-764c-aab6-380cb77612fb",
        "storage_key": "property/5174477956579328/019f1504-26d4-764c-aab6-380cb77612fb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr4vm2wD2XIYRE5YL0qrwAfk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_70d9ad8672deef67a3045308",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "San Antonio International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "9800 Airport Blvd, San Antonio, TX 78216, USA",
      "poi_short_description": "Airport offering international flights plus eateries & car-rental options.",
      "poi_long_description": "Airport offering international flights plus eateries & car-rental options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1507-223b-7179-a22a-5b9d6ec0ae93.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1507-223b-7179-a22a-5b9d6ec0ae93",
        "storage_key": "property/5174477956579328/019f1507-223b-7179-a22a-5b9d6ec0ae93.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.flysanantonio.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18041828760938859602&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "san-antonio-international-airport",
      "poi_latitude": "29.5331282",
      "poi_longitude": "-98.4705422",
      "poi_miles_from_property": "16.2 mi",
      "poi_walking_minutes": "6 hours 4 mins",
      "poi_biking_minutes": "2 hours 2 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 210-207-3433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1507-36ae-735f-9155-db25b1a3c652.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1507-36ae-735f-9155-db25b1a3c652",
        "storage_key": "property/5174477956579328/019f1507-36ae-735f-9155-db25b1a3c652.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ4DLsbuKXIYRUswvGqtzYfo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_6645fcd15808ea7cd5010e14",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Methodist Hospital Stone Oak",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1139 E Sonterra Blvd, San Antonio, TX 78258, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1507-1eab-77ac-9a4d-316ccc025468.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1507-1eab-77ac-9a4d-316ccc025468",
        "storage_key": "property/5174477956579328/019f1507-1eab-77ac-9a4d-316ccc025468.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "https://www.sahealth.com/locations/methodist-hospital-stone-oak?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=7066658014942627455&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "methodist-hospital-stone-oak",
      "poi_latitude": "29.6162229",
      "poi_longitude": "-98.4743864",
      "poi_miles_from_property": "17.6 mi",
      "poi_walking_minutes": "6 hours 38 mins",
      "poi_biking_minutes": "1 hour 54 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 210-638-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26d4-764c-aab6-3dd634ae8abb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26d4-764c-aab6-3dd634ae8abb",
        "storage_key": "property/5174477956579328/019f1504-26d4-764c-aab6-3dd634ae8abb.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJz4q-ivmJXIYRf4bSGQbQEWI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_beaf5dec50811460510455a5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "North Central Baptist Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "520 Madison Oak Dr, San Antonio, TX 78258, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1507-2add-768f-a748-fc1ff865e992.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1507-2add-768f-a748-fc1ff865e992",
        "storage_key": "property/5174477956579328/019f1507-2add-768f-a748-fc1ff865e992.webp",
        "width": 1280,
        "height": 865
      },
      "poi_business_url": "https://www.baptisthealthsystem.com/locations/detail/north-central-baptist-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=9906410289780053303&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-central-baptist-hospital",
      "poi_latitude": "29.6204476",
      "poi_longitude": "-98.4908558",
      "poi_miles_from_property": "16.9 mi",
      "poi_walking_minutes": "6 hours 23 mins",
      "poi_biking_minutes": "1 hour 51 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 210-297-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26d4-764c-aab6-3dd634ae8abb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26d4-764c-aab6-3dd634ae8abb",
        "storage_key": "property/5174477956579328/019f1504-26d4-764c-aab6-3dd634ae8abb.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJVwCXMoxjXIYRN1WdEayjeok",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_bbc168629e1ea114e06b7df1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "JP Morgan Chase San Antonio Corporate Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "20855 Stone Oak Pkwy, San Antonio, TX 78258, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1507-267f-741f-9dd6-85214bc0b338.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1507-267f-741f-9dd6-85214bc0b338",
        "storage_key": "property/5174477956579328/019f1507-267f-741f-9dd6-85214bc0b338.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chase.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13319224428348059911&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jp-morgan-chase-san-antonio-corporate-center",
      "poi_latitude": "29.6523732",
      "poi_longitude": "-98.4560528",
      "poi_miles_from_property": "19.8 mi",
      "poi_walking_minutes": "7 hours 31 mins",
      "poi_biking_minutes": "2 hours 16 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 800-935-9935",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26d4-764c-aab6-380cb77612fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26d4-764c-aab6-380cb77612fb",
        "storage_key": "property/5174477956579328/019f1504-26d4-764c-aab6-380cb77612fb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcWdVYrGJXIYRBzFknwxk17g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_697f84949d399b87ae14dc39",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "iHeartMedia",
      "poi_type": "Major Employers & Offices",
      "poi_address": "20880 Stone Oak Pkwy 1st floor, San Antonio, TX 78258, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1507-2698-72b2-958f-5a39e8bd074b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1507-2698-72b2-958f-5a39e8bd074b",
        "storage_key": "property/5174477956579328/019f1507-2698-72b2-958f-5a39e8bd074b.webp",
        "width": 1280,
        "height": 222
      },
      "poi_business_url": "https://www.iheartmedia.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11463547426592997435&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "iheartmedia",
      "poi_latitude": "29.647536",
      "poi_longitude": "-98.453984",
      "poi_miles_from_property": "20.0 mi",
      "poi_walking_minutes": "7 hours 35 mins",
      "poi_biking_minutes": "2 hours 12 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 210-507-4455",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26d4-764c-aab6-380cb77612fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26d4-764c-aab6-380cb77612fb",
        "storage_key": "property/5174477956579328/019f1504-26d4-764c-aab6-380cb77612fb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD_6c7bCJXIYRO0Dr46WzFp8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "television_studio"
    },
    {
      "id": "ec_28c25c14e9f8135562538020",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Marathon Petroleum Corporation - Regional Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "19100 Ridgewood Pkwy, San Antonio, TX 78259, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1507-2b9a-76f8-8f97-1e265051de70.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1507-2b9a-76f8-8f97-1e265051de70",
        "storage_key": "property/5174477956579328/019f1507-2b9a-76f8-8f97-1e265051de70.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.marathonpetroleum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4640742790973244036&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marathon-petroleum-corporation---regional-office",
      "poi_latitude": "29.6166393",
      "poi_longitude": "-98.4598616",
      "poi_miles_from_property": "18.9 mi",
      "poi_walking_minutes": "7 hours 5 mins",
      "poi_biking_minutes": "1 hour 58 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 419-422-2121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26d4-764c-aab6-380cb77612fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26d4-764c-aab6-380cb77612fb",
        "storage_key": "property/5174477956579328/019f1504-26d4-764c-aab6-380cb77612fb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0d-Zk4uJXIYRhELqDfs6Z0A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_1a70bf837dc332dd7e001f36",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Ridgewood Plaza",
      "poi_type": "Major Employers & Offices",
      "poi_address": "19026 Ridgewood Pkwy, San Antonio, TX 78259, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://worthsa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5962746930401342007&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ridgewood-plaza",
      "poi_latitude": "29.6176842",
      "poi_longitude": "-98.4568533",
      "poi_miles_from_property": "18.8 mi",
      "poi_walking_minutes": "7 hours 4 mins",
      "poi_biking_minutes": "1 hour 58 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 210-822-5220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26d4-764c-aab6-380cb77612fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26d4-764c-aab6-380cb77612fb",
        "storage_key": "property/5174477956579328/019f1504-26d4-764c-aab6-380cb77612fb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPSMSDoyJXIYRN3IfwL3uv1I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_504da52a9410761e00bdf974",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "The University of Texas at San Antonio",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Physical Education Building, 1 UTSA Circle, San Antonio, TX 78249, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1507-28d0-73a9-8227-e9a4ade801f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1507-28d0-73a9-8227-e9a4ade801f3",
        "storage_key": "property/5174477956579328/019f1507-28d0-73a9-8227-e9a4ade801f3.webp",
        "width": 1280,
        "height": 834
      },
      "poi_business_url": "https://www.utsa.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2658632929587635980&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-university-of-texas-at-san-antonio",
      "poi_latitude": "29.5830733",
      "poi_longitude": "-98.6198779",
      "poi_miles_from_property": "10.7 mi",
      "poi_walking_minutes": "4 hours 2 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 210-458-4011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26f8-71e0-bc16-eabd3e3e79a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26f8-71e0-bc16-eabd3e3e79a5",
        "storage_key": "property/5174477956579328/019f1504-26f8-71e0-bc16-eabd3e3e79a5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3X9l1n1mXIYRDCc6PJBc5SQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_2d4fe111b3bfd592b3de621e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "Valero",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Valero Way, San Antonio, TX 78249, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1507-2d38-73ae-a81e-d7c0bfa3f3e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1507-2d38-73ae-a81e-d7c0bfa3f3e8",
        "storage_key": "property/5174477956579328/019f1507-2d38-73ae-a81e-d7c0bfa3f3e8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.valero.com/ourbusiness/ourlocations/offices/pages/valerocorporateheadquarters.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=16201185604516536043&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "valero",
      "poi_latitude": "29.5869869",
      "poi_longitude": "-98.6070957",
      "poi_miles_from_property": "11.6 mi",
      "poi_walking_minutes": "4 hours 14 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 210-345-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26d4-764c-aab6-380cb77612fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26d4-764c-aab6-380cb77612fb",
        "storage_key": "property/5174477956579328/019f1504-26d4-764c-aab6-380cb77612fb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv1eqHI5mXIYR615hQXgs1uA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_8312cb07b0896d105573c370",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "USAA Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9800 Fredericksburg Rd, San Antonio, TX 78288, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1507-2d38-73ae-a81e-dad794a8e8e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1507-2d38-73ae-a81e-dad794a8e8e8",
        "storage_key": "property/5174477956579328/019f1507-2d38-73ae-a81e-dad794a8e8e8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.usaa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7341051404387659836&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "usaa-corporate-office",
      "poi_latitude": "29.5371902",
      "poi_longitude": "-98.5752478",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 800-531-8722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1504-26d4-764c-aab6-380cb77612fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1504-26d4-764c-aab6-380cb77612fb",
        "storage_key": "property/5174477956579328/019f1504-26d4-764c-aab6-380cb77612fb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyyb6ITJnXIYRPLBolFun4GU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_950d4f861646f4ecf1f11079",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "poi_name": "San Antonio International Airport",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9800 Airport Blvd, San Antonio, TX 78216, USA",
      "poi_short_description": "Airport offering international flights plus eateries & car-rental options.",
      "poi_long_description": "Airport offering international flights plus eateries & car-rental options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1507-223b-7179-a22a-5b9d6ec0ae93.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1507-223b-7179-a22a-5b9d6ec0ae93",
        "storage_key": "property/5174477956579328/019f1507-223b-7179-a22a-5b9d6ec0ae93.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.flysanantonio.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18041828760938859602&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "san-antonio-international-airport",
      "poi_latitude": "29.5331282",
      "poi_longitude": "-98.4705422",
      "poi_miles_from_property": "16.2 mi",
      "poi_walking_minutes": "6 hours 4 mins",
      "poi_biking_minutes": "2 hours 2 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 210-207-3433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f1507-36ae-735f-9155-db25b1a3c652.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1507-36ae-735f-9155-db25b1a3c652",
        "storage_key": "property/5174477956579328/019f1507-36ae-735f-9155-db25b1a3c652.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ4DLsbuKXIYRUswvGqtzYfo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    }
  ],
  "office_hours": [
    {
      "id": "custom_a884edec-ad7a-4a26-b510-a9c45cf1587a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_1c07e2e4-e678-4345-b676-60cc6bfaa763",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_c115b4e9-61e9-4451-b397-c7dd49581ee9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_8d804b55-c81b-447f-aaaa-3ad165794aaf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_75927dbc-d419-4c9f-afaf-07d8422285af",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "19:00"
    },
    {
      "id": "custom_43d4cef6-3698-4b92-95b8-b43a013434dd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "19:00"
    },
    {
      "id": "custom_e50d52de-39e2-43a4-8551-984579f8d7dd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "day": "SUN",
      "open_time": "13:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_7094ab66-fe17-48e1-ab3d-8854ccd333c8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "rating": "5.0",
      "name": "Tracy Benson",
      "text": "We are so excited to move our son into his first apartment here! The manager, Jennifer Garza, has been absolutely wonderful!  Not only was she patient in explaining everything and answering all of our questions but she made the whole process that should have seemed like a chore into a fun, enjoyable experience!",
      "date": "2026-05-31",
      "title": ""
    },
    {
      "id": "custom_8b1a8235-1c1a-4461-a25d-5772236ad3b9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "rating": "5.0",
      "name": "Melissa Contreras",
      "text": "I’ve had a very pleasant experience living at this apartment complex. The environment is generally quiet and peaceful, which has made it a comfortable place to call home. I haven’t had any issues with my neighbors, and everyone seems respectful and considerate.\nThe front office staff has been especially great—they consistently provide excellent customer service and are very responsive whenever I have questions or need assistance. Overall, it’s been a positive living experience, and I would recommend this community to others looking for a well-managed and calm place to live.",
      "date": "2026-04-17",
      "title": ""
    },
    {
      "id": "custom_2908ba17-5301-4bb4-b559-72803c0a7db7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "rating": "5.0",
      "name": "Tanzania Talbot",
      "text": "As a Florida native who recently moved to San Antonio, I’ve genuinely been enjoying my stay at Kenzie Park .The transition was a lot easier thanks to how friendly and welcoming the staff have been throughout the entire moving process.\n\nAny time I’ve had a minor inconvenience or maintenance issue, it’s been handled promptly and taken care of the right way, which I really appreciate. The community is quiet, the location is convenient, and overall it feels like a comfortable place to call home.\n\nHighly recommend living here!",
      "date": "2025-12-11",
      "title": ""
    },
    {
      "id": "custom_6ed0a0e2-53fe-4acb-a0b4-8f5595c589c9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "rating": "5.0",
      "name": "Eian Prieto",
      "text": "Currently moved in a few months ago, and I have no complaints so far! Management is lovely, and I appreciate how things get done here relatively fast. Not to mention the amazing deals they offered us when we first moved in, which helped make a very smooth transition into our new place",
      "date": "2026-01-04",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_4179dbd692eba46736ad518e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "YouTube channel: American Landmark",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f14c4-1c20-749b-8d0c-9118243f8f55.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c4-1c20-749b-8d0c-9118243f8f55",
        "storage_key": "property/5174477956579328/019f14c4-1c20-749b-8d0c-9118243f8f55.webp",
        "width": 480,
        "height": 360
      },
      "virtual_tour_title": "Kenzie Park Community Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.youtube.com/embed/F6czGhUq-vA"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa45-9580-7637-a9f5-6bc3c1bdddab",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "kenzie-park",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328"
    },
    {
      "lead_collector_id": "0198aa45-95e4-77ed-8f56-190fb2e60b98",
      "lead_source": "FACEBOOK_ADS",
      "name": "kenzie-park",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328"
    },
    {
      "lead_collector_id": "0198aa45-9647-741b-9f88-0d5535018e0d",
      "lead_source": "LANDING_PAGE",
      "name": "kenzie-park",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "custom",
      "page_item_url": "san-antonio-apartments-in-unit-washer-dryer-163",
      "search_query": "apartments with in-unit washer dryer San Antonio",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Washer Dryer",
      "h2_subtitle": "Discover the convenience of living in San Antonio with Kenzie Park's chic apartments featuring in-unit washer and dryer amenities. Experience comfort and style daily.",
      "page_copy": "Kenzie Park offers the perfect blend of convenience and style with our one and two-bedroom apartments featuring an in-unit washer dryer in San Antonio. Imagine the ease of doing laundry right in the comfort of your own space, freeing up time to enjoy our vibrant community amenities.\n\nLocated in the heart of San Antonio's Westover Hills neighborhood, our apartments with in-unit washer dryer provide residents with modern comforts and convenience. Relish in additional features like a fully-equipped kitchen and crown molding. Dive into relaxation with our resort-style pool or stay active in our fitness center. Your perfect home in Bexar County awaits at Kenzie Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f6c0f-4f6d-7164-ab4a-f7a0ecdcdca7.webp",
      "featured_image_media": {
        "alt_text": "Kitchen and dining area with granite countertops, stainless steel appliances, and a dining table with chairs.",
        "public_id": "019f6c0f-4f6d-7164-ab4a-f7a0ecdcdca7",
        "storage_key": "property/5174477956579328/019f6c0f-4f6d-7164-ab4a-f7a0ecdcdca7.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "San Antonio Apts with In-Unit Washer Dryer",
      "seo_description": "Explore Kenzie Park apartments in San Antonio, featuring in-unit washer dryer and resort-style amenities for modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "custom",
      "page_item_url": "westover-hills-resort-style-pool-apartments-538",
      "search_query": "resort-style pool apartments in Westover Hills",
      "category": "Amenity",
      "h1_title": "Resort-Style Pool Apartments",
      "h2_subtitle": "Experience luxury living at Kenzie Park in Westover Hills with our resort-style pool. Your perfect home in San Antonio's vibrant neighborhood awaits.",
      "page_copy": "Nestled in the sought-after Westover Hills area, Kenzie Park stands out with its luxurious resort-style pool and exceptional apartment offerings. Dive into relaxation and enjoy a refreshing swim in our beautifully maintained pool, a unique feature that adds a splash of luxury to everyday living.\n\nOur community in San Antonio provides a blend of comfort and style, featuring chic one and two-bedroom apartments equipped with modern amenities such as a fully-equipped kitchen, in-unit washer/dryer, and a lively resident clubhouse. Whether you're soaking up the sun by the poolside or grilling at our outdoor BBQ area, life at Kenzie Park is all about indulgence and convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f6c0f-4f6d-7164-ab4a-f7a0ecdcdca7.webp",
      "featured_image_media": {
        "alt_text": "Kitchen and dining area with granite countertops, stainless steel appliances, and a dining table with chairs.",
        "public_id": "019f6c0f-4f6d-7164-ab4a-f7a0ecdcdca7",
        "storage_key": "property/5174477956579328/019f6c0f-4f6d-7164-ab4a-f7a0ecdcdca7.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Westover Hills Resort-Style Pool Apts",
      "seo_description": "Discover Kenzie Park in Westover Hills, San Antonio, offering resort-style pool apartments with modern amenities. Perfect home in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "custom",
      "page_item_url": "apartments-near-78251-with-fitness-center-571",
      "search_query": "fitness center apartments near 78251",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments Near 78251",
      "h2_subtitle": "Live near 78251 at Kenzie Park, where fitness amenities are part of your lifestyle. Experience the ease of having a state-of-the-art fitness center on-site.",
      "page_copy": "Situated conveniently in San Antonio near the 78251 area, Kenzie Park offers residents a comprehensive fitness center, perfect for maintaining an active lifestyle. Our fitness center apartments enrich your daily routine with state-of-the-art equipment just steps away from your front door.\n\nBeyond the fitness center, our vibrant community provides chic one and two-bedroom apartments designed with modern comforts like in-unit washer/dryer and a fully-equipped kitchen. The resort-style pool and BBQ grill areas make leisure days even more enjoyable. Located in Westover Hills, living at Kenzie Park means enjoying both luxury and convenience in a prime San Antonio location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f6c0f-4f6d-7164-ab4a-f7a0ecdcdca7.webp",
      "featured_image_media": {
        "alt_text": "Kitchen and dining area with granite countertops, stainless steel appliances, and a dining table with chairs.",
        "public_id": "019f6c0f-4f6d-7164-ab4a-f7a0ecdcdca7",
        "storage_key": "property/5174477956579328/019f6c0f-4f6d-7164-ab4a-f7a0ecdcdca7.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "San Antonio Apts Near 78251 with Fitness Center",
      "seo_description": "Find fitness center apartments at Kenzie Park near 78251, San Antonio. Enjoy a prime location with modern amenities and resort-style features.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "custom",
      "page_item_url": "bexar-county-modern-apartments-with-dishwasher-200",
      "search_query": "modern apartments with dishwasher in Bexar County",
      "category": "Amenity",
      "h1_title": "Modern Apartments with Dishwasher",
      "h2_subtitle": "Discover Kenzie Park's modern apartments in Bexar County, equipped with all conveniences, including a dishwasher, ensuring a stylish and comfortable living experience.",
      "page_copy": "Kenzie Park proudly offers modern apartments in Bexar County, featuring essential amenities like a dishwasher that complement contemporary living. Our one and two-bedroom homes are thoughtfully designed, providing the perfect blend of functionality and style to create a welcoming atmosphere for you and your family.\n\nLocated in the vibrant Westover Hills neighborhood of San Antonio, our community extends beyond the interiors. Residents enjoy a variety of luxury features such as a resort-style pool, fully-equipped kitchen, in-unit washer/dryer, and cozy crown molding. Experience an unparalleled lifestyle at Kenzie Park, where every detail is tailored to enhance comfort and convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f6c0f-4f6d-7164-ab4a-f7a0ecdcdca7.webp",
      "featured_image_media": {
        "alt_text": "Kitchen and dining area with granite countertops, stainless steel appliances, and a dining table with chairs.",
        "public_id": "019f6c0f-4f6d-7164-ab4a-f7a0ecdcdca7",
        "storage_key": "property/5174477956579328/019f6c0f-4f6d-7164-ab4a-f7a0ecdcdca7.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Modern Apartments with Dishwasher, Bexar County",
      "seo_description": "Explore modern Bexar County apartments at Kenzie Park, San Antonio, equipped with a dishwasher and resort-style amenities for a stylish lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "custom",
      "page_item_url": "san-antonio-air-conditioned-apartments-266",
      "search_query": "air conditioned apartments San Antonio TX",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in San Antonio",
      "h2_subtitle": "Stay cool in San Antonio, TX with air-conditioned apartments at Kenzie Park. Our homes offer the comfort you desire in a prime location.",
      "page_copy": "At Kenzie Park in San Antonio, TX, enjoy the luxury of air-conditioned apartments designed to keep you comfortable year-round. Our community understands the importance of climate control, especially in Texas, which is why all our stylish one and two-bedroom apartments are equipped with efficient air conditioning systems.\n\nSituated in the lively Westover Hills neighborhood, Kenzie Park offers more than just cooling convenience. Residents can indulge in top-tier amenities including a resort-style pool, fitness center, and a welcoming resident clubhouse. Experience comfort, style, and modern conveniences all in one inviting community in Bexar County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f6c0f-4f6d-7164-ab4a-f7a0ecdcdca7.webp",
      "featured_image_media": {
        "alt_text": "Kitchen and dining area with granite countertops, stainless steel appliances, and a dining table with chairs.",
        "public_id": "019f6c0f-4f6d-7164-ab4a-f7a0ecdcdca7",
        "storage_key": "property/5174477956579328/019f6c0f-4f6d-7164-ab4a-f7a0ecdcdca7.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments, San Antonio TX",
      "seo_description": "Discover air-conditioned apartments at Kenzie Park in San Antonio, TX. Enjoy modern amenities and comfort in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-westover-hills-281",
      "search_query": "one bedroom apartments westover hills san antonio",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Westover Hills",
      "h2_subtitle": "Explore one bedroom apartments at Kenzie Park, located in the desirable Westover Hills neighborhood of San Antonio. Modern living awaits you!",
      "page_copy": "Nestled in the sought-after Westover Hills area, Kenzie Park offers one bedroom apartments perfect for those seeking a modern and convenient lifestyle in San Antonio. Each apartment is designed with contemporary features such as a fully-equipped kitchen and in-unit washer/dryer, ensuring comfort and ease in daily living.\n\nBeyond the stylish interiors, residents of Kenzie Park can enjoy a range of luxury amenities. Dive into our sparkling resort-style pool, work out in the state-of-the-art fitness center, or host gatherings in the resident clubhouse. Discover a vibrant community tailored to enhancing your living experience in San Antonio, TX.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f6c0f-4f6d-7164-ab4a-f7a0ecdcdca7.webp",
      "featured_image_media": {
        "alt_text": "Kitchen and dining area with granite countertops, stainless steel appliances, and a dining table with chairs.",
        "public_id": "019f6c0f-4f6d-7164-ab4a-f7a0ecdcdca7",
        "storage_key": "property/5174477956579328/019f6c0f-4f6d-7164-ab4a-f7a0ecdcdca7.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments, Westover Hills San Antonio",
      "seo_description": "Find one bedroom apartments at Kenzie Park in Westover Hills, San Antonio. Enjoy modern comfort and premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "custom",
      "page_item_url": "bexar-county-two-bedroom-apartments-31",
      "search_query": "two bedroom apartments bexar county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Bexar County",
      "h2_subtitle": "Kenzie Park in Bexar County offers spacious two bedroom apartments. Enjoy modern amenities and community features in a prime location.",
      "page_copy": "Experience the spacious and modern two bedroom apartments at Kenzie Park, located in the heart of Bexar County. Our thoughtfully designed homes feature contemporary comforts such as a fully-equipped kitchen and in-unit washer/dryer, making them ideal for families or roommates seeking convenience and style.\n\nLiving at Kenzie Park comes with an array of community amenities that enhance your lifestyle. Relax by the sparkling pool, stay fit at the on-site fitness center, or socialize in the resident clubhouse. All of this, nestled in the vibrant Westover Hills neighborhood, provides the perfect setting for your new home in San Antonio, TX.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f6c0f-4f6d-7164-ab4a-f7a0ecdcdca7.webp",
      "featured_image_media": {
        "alt_text": "Kitchen and dining area with granite countertops, stainless steel appliances, and a dining table with chairs.",
        "public_id": "019f6c0f-4f6d-7164-ab4a-f7a0ecdcdca7",
        "storage_key": "property/5174477956579328/019f6c0f-4f6d-7164-ab4a-f7a0ecdcdca7.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments, Bexar County",
      "seo_description": "Explore two bedroom apartments at Kenzie Park in Bexar County. Enjoy modern amenities and a vibrant community in San Antonio, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "custom",
      "page_item_url": "apartments-near-ut-health-science-center-298",
      "search_query": "apartments near UT Health Science Center San Antonio",
      "category": "School",
      "h1_title": "Apartments Near UT Health Science Center",
      "h2_subtitle": "Discover convenient living at Kenzie Park, near UT Health Science Center in San Antonio. Our community offers modern comforts and amenities.",
      "page_copy": "For those looking to reside close to the UT Health Science Center in San Antonio, Kenzie Park provides an excellent choice with its modern and convenient apartment options. Our one and two-bedroom apartments are designed with comfort in mind, featuring amenities such as fully-equipped kitchens and in-unit washer/dryers, perfect for students or professionals seeking easy access to the university.\n\nLocated in the vibrant Westover Hills neighborhood, Kenzie Park is more than just a place to live. Enjoy community perks like a resort-style pool, fitness center, and a welcoming resident clubhouse. This proximity to UT Health Science Center, paired with our excellent amenities, makes Kenzie Park an ideal home base in San Antonio, TX.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f6c0f-4f6d-7164-ab4a-f7a0ecdcdca7.webp",
      "featured_image_media": {
        "alt_text": "Kitchen and dining area with granite countertops, stainless steel appliances, and a dining table with chairs.",
        "public_id": "019f6c0f-4f6d-7164-ab4a-f7a0ecdcdca7",
        "storage_key": "property/5174477956579328/019f6c0f-4f6d-7164-ab4a-f7a0ecdcdca7.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near UT Health Science Center",
      "seo_description": "Find stylish apartments near UT Health Science Center San Antonio at Kenzie Park. Enjoy convenience and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "custom",
      "page_item_url": "apartments-close-to-st-marys-university-tx-315",
      "search_query": "apartments close to St. Mary's University TX",
      "category": "School",
      "h1_title": "Apartments Close to St. Mary's University",
      "h2_subtitle": "Kenzie Park offers convenient living with modern amenities close to St. Mary's University in San Antonio, TX. Discover your new home today.",
      "page_copy": "Find your ideal home at Kenzie Park, strategically located for easy access to St. Mary's University in San Antonio, TX. Our chic apartments are perfect for students and professionals alike, featuring amenities like fully-equipped kitchens and in-unit washer/dryers to make daily life more convenient.\n\nBeyond the beautifully designed interiors, Kenzie Park provides a wealth of community amenities including a resort-style pool, fitness center, and vibrant resident clubhouse. Situated in the welcoming neighborhood of Westover Hills, our community offers an ideal living environment close to academic and social opportunities at St. Mary's University.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f6c0f-4f6d-7164-ab4a-f7a0ecdcdca7.webp",
      "featured_image_media": {
        "alt_text": "Kitchen and dining area with granite countertops, stainless steel appliances, and a dining table with chairs.",
        "public_id": "019f6c0f-4f6d-7164-ab4a-f7a0ecdcdca7",
        "storage_key": "property/5174477956579328/019f6c0f-4f6d-7164-ab4a-f7a0ecdcdca7.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to St. Mary's University TX",
      "seo_description": "Live close to St. Mary's University TX at Kenzie Park. Enjoy modern apartments and convenient amenities in San Antonio.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "custom",
      "page_item_url": "family-friendly-apartments-western-hills-906",
      "search_query": "family-friendly apartments by Great Hearts Western Hills in Westover Hills",
      "category": "School",
      "h1_title": "Family-Friendly Apartments by Great Hearts Western Hills",
      "h2_subtitle": "Kenzie Park offers family-friendly apartment living near Great Hearts Western Hills. Enjoy a vibrant community with modern amenities in Westover Hills.",
      "page_copy": "Kenzie Park stands as an ideal choice for families seeking apartments in the vibrant Westover Hills area, close by to Great Hearts Western Hills. Our family-friendly apartments are designed to accommodate the needs of a growing family, with spacious one and two-bedroom options that include modern comforts like fully-equipped kitchens and in-unit washers and dryers.\n\nLiving at Kenzie Park means enjoying more than just a place to stay; our community offers family-oriented amenities such as a sparkling pool, a fitness center, and a resident clubhouse, perfect for hosting gatherings and creating memories. Proximity to highly-regarded schools and the peaceful neighborhood makes Kenzie Park a excellent family residence in San Antonio, providing the perfect balance of comfort and convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f6c0f-4f6d-7164-ab4a-f7a0ecdcdca7.webp",
      "featured_image_media": {
        "alt_text": "Kitchen and dining area with granite countertops, stainless steel appliances, and a dining table with chairs.",
        "public_id": "019f6c0f-4f6d-7164-ab4a-f7a0ecdcdca7",
        "storage_key": "property/5174477956579328/019f6c0f-4f6d-7164-ab4a-f7a0ecdcdca7.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Family-Friendly Apartments by Great Hearts Western Hills",
      "seo_description": "Explore family-friendly apartments by Great Hearts Western Hills at Kenzie Park. Ideal living in Westover Hills, San Antonio with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "custom",
      "page_item_url": "apartments-near-royal-point-academy-bexar-county-465",
      "search_query": "apartments near Royal Point Academy Bexar County",
      "category": "School",
      "h1_title": "Apartments Near Royal Point Academy",
      "h2_subtitle": "Kenzie Park offers exceptional living near Royal Point Academy in Bexar County. Discover our stylish apartments today.",
      "page_copy": "Located conveniently in Bexar County, Kenzie Park provides an ideal home for those seeking comfortable living near Royal Point Academy. Our modern one and two-bedroom apartments feature amenities like fully-equipped kitchens and in-unit washers and dryers, perfect for creating a cozy home environment.\n\nIn addition to our beautifully designed interiors, residents can enjoy a variety of community amenities such as a resort-style pool, fitness center, and lively resident clubhouse. Nestled in the inviting Westover Hills neighborhood, Kenzie Park offers easy access to educational facilities like Royal Point Academy, making it a prime location for students and families alike seeking a harmonious blend of convenience and lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f6c0f-4f6d-7164-ab4a-f7a0ecdcdca7.webp",
      "featured_image_media": {
        "alt_text": "Kitchen and dining area with granite countertops, stainless steel appliances, and a dining table with chairs.",
        "public_id": "019f6c0f-4f6d-7164-ab4a-f7a0ecdcdca7",
        "storage_key": "property/5174477956579328/019f6c0f-4f6d-7164-ab4a-f7a0ecdcdca7.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Royal Point Academy",
      "seo_description": "Explore modern living at Kenzie Park, close to Royal Point Academy Bexar County. Enjoy stylish amenities and convenient access in San Antonio.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "custom",
      "page_item_url": "family-friendly-apartments-linton-elementary-san-antonio-791",
      "search_query": "family-friendly apartments near Linton Elementary School San Antonio",
      "category": "School",
      "h1_title": "Family-Friendly Apartments Near Linton Elementary",
      "h2_subtitle": "Discover family-friendly living at Kenzie Park, just minutes from Linton Elementary School in San Antonio. Perfect for growing families.",
      "page_copy": "Kenzie Park offers the perfect family-friendly setting for those searching for apartments near Linton Elementary School in San Antonio. Our spacious one and two-bedroom units are tailored to accommodate families, featuring essential amenities like in-unit washer/dryer and fully-equipped kitchens that ease daily tasks.\n\nThe community at Kenzie Park extends beyond the apartment walls, offering a resort-style pool, fitness center, and clubhouse, perfect for family gatherings and recreation. Located in the heart of Westover Hills, parents will appreciate the proximity to Linton Elementary School and the convenience it brings, ensuring a balanced lifestyle of education, comfort, and leisure.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f6c0f-4f6d-7164-ab4a-f7a0ecdcdca7.webp",
      "featured_image_media": {
        "alt_text": "Kitchen and dining area with granite countertops, stainless steel appliances, and a dining table with chairs.",
        "public_id": "019f6c0f-4f6d-7164-ab4a-f7a0ecdcdca7",
        "storage_key": "property/5174477956579328/019f6c0f-4f6d-7164-ab4a-f7a0ecdcdca7.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Family-Friendly Apts Near Linton Elementary School",
      "seo_description": "At Kenzie Park, find family-friendly living near Linton Elementary School San Antonio. Spacious apartments and modern amenities await.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174477956579328",
      "source": "custom",
      "page_item_url": "apartments-near-john-jay-high-school-78251-485",
      "search_query": "apartments near John Jay High School 78251",
      "category": "School",
      "h1_title": "Apartments Near John Jay High School 78251",
      "h2_subtitle": "Find the perfect home at Kenzie Park, just a short distance from John Jay High School. Experience convenient living in the 78251 area.",
      "page_copy": "Situated in the dynamic 78251 area, Kenzie Park is ideally located for those looking to live near John Jay High School. Our modern one and two-bedroom apartments offer an optimal living experience with features like fully-equipped kitchens, in-unit washer/dryer, and elegant touches such as crown molding.\n\nBeyond the comfort of the apartments themselves, Kenzie Park provides residents with premium community amenities including a sparkling swimming pool, fitness center, and a vibrant resident clubhouse. With its close proximity to John Jay High School, Kenzie Park is perfect for students and families seeking convenient, quality education alongside upscale living in San Antonio's Westover Hills neighborhood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019f6c0f-4f6d-7164-ab4a-f7a0ecdcdca7.webp",
      "featured_image_media": {
        "alt_text": "Kitchen and dining area with granite countertops, stainless steel appliances, and a dining table with chairs.",
        "public_id": "019f6c0f-4f6d-7164-ab4a-f7a0ecdcdca7",
        "storage_key": "property/5174477956579328/019f6c0f-4f6d-7164-ab4a-f7a0ecdcdca7.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near John Jay High School 78251",
      "seo_description": "Kenzie Park offers modern living near John Jay High School in the 78251 area. Enjoy quality amenities and a prime location in San Antonio.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2288"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "2505043903"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a33\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a33\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4981187"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-PBCCS5P"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "2"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8443201072"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "72bc1811f12ffb54"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/gow3k46qp2m"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/d7259ec3-ed62-4d4c-a2d4-488146273c83"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "361-203-2820"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjFOanNmaXdKZWJWblR5Z1c5L2F4YUE9PSIsInZhbHVlIjoiaEx5NTRHQWFMNVlhbE5wb2lEcG5FQT09IiwibWFjIjoiYzNhMzg3OGVlZWRhYmUzMTZmOTQwOWY3YTIxZWY3MjE3YzkxZTA3MWZlNWM0MWU4YTJkN2E1MTk0ZmE2ZjUxZiJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2288",
  "custom_repli_id": "2505043903",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a33\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a33\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "4981187",
  "custom_google_gtm_id": "GTM-PBCCS5P",
  "custom_rollout_phase": "2",
  "custom_ads_subscription": "full_stack",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "8443201072",
  "custom_knock_community_id": "72bc1811f12ffb54",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/gow3k46qp2m",
  "custom_self_guided_tour_url": "https://selftournow.com/property/d7259ec3-ed62-4d4c-a2d4-488146273c83",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "361-203-2820",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjFOanNmaXdKZWJWblR5Z1c5L2F4YUE9PSIsInZhbHVlIjoiaEx5NTRHQWFMNVlhbE5wb2lEcG5FQT09IiwibWFjIjoiYzNhMzg3OGVlZWRhYmUzMTZmOTQwOWY3YTIxZWY3MjE3YzkxZTA3MWZlNWM0MWU4YTJkN2E1MTk0ZmE2ZjUxZiJ9",
  "custom_household_income_qualification_multiplier": "3"
};

export const generatedAt = '2026-10-09T16:38:33.671Z';
